import secureLocalStorage from "react-secure-storage";
import { CircularProgress, Hidden } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { filterBy, orderBy, process } from "@progress/kendo-data-query";
import { Window } from "@progress/kendo-react-dialogs";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { Popup } from "@progress/kendo-react-popup";
import { formatNumber } from "@telerik/kendo-intl";
import * as FileSaver from "file-saver";
import * as moment from "moment";
import React, { useEffect,  useState } from "react";
import { toastr } from "react-redux-toastr";
import { NavLink, useHistory } from "react-router-dom";
import * as XLSX from "xlsx";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/RiskDashboard.scss";
import ColumnMenuFilter from "../Dashboard/ColumnMenuFilter";
import { CustomFieldSearchMenu } from "../Dashboard/CustomFieldSearchMenu";
import { SearchMenu } from "../Dashboard/SearchMenu";
import ExistingControlCell from "./Component/ExistingControlCell";
import GridExpandComponent from "./Component/GridExpandCompoent";
import ImpactEditComponent from "./Component/ImpactEditComponent";
import OverallComponenant from "./Component/OverallComponenant";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskAlertStackHolderComponent from "./Component/RiskAlertStackHolderComponent";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskCommonCell from "./Component/RiskCommonCell";
import RiskCustomFieldDropdownCell from "./Component/RiskCustomFieldDropdownCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import RiskFrequencyComponent from "./Component/RiskFrequencyComponent";
import RiskProximityDateCell from "./Component/RiskProximityDateCell";
import StatusComponent from "./Component/StatusComponent";
import { MitigationExpandEdit } from "./MitigationExpandEdit";
import OwnerDropDownCell from "./OwnerDropDownCell";
import RiskColumns from "./RiskColumns.json";
import DropDownCell from "./RiskTypeDropDownCell";
import ThreatAndOpportunities from "./ThreatAndOpportunities";
import RiskTitleCell from "./Component/RiskTitleCell";
import RiskProgressPopup from "./Component/RiskProgressPopup";
import CopyRiskAndAction from "./Component/CopyRiskAndAction";
import PersistenceRisk from "./PersistenceRisk.json";
import ActionPersistence from "./ActionPersistence.json";
import RiskCustomFieldSingleDropdownCell from "./Component/RiskCustomFieldSingleDropdownCell";
import RiskCustomFieldFreeText from "./Component/RiskCustomFieldFreeText";
import RiskCustomFieldDate from "./Component/RiskCustomFieldDate";
import RiskCustomFieldNumeric from "./Component/RiskCustomFieldNumeric";
import QualitativeImpactEditComponent from "./Component/QualitativeImpactEditComponent";
import { ColumnMenuCheckboxFilter } from "../Dashboard/ColumnMenuCheckboxFilter";
import RiskRegisterFormView from "./Component/RiskRegisterFormView";
import { useRef } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import {Errorlogtreeview,TreeItem} from "./Component/Errorlogtreeview"
import ValidateAction from "../Dashboard/ValidateAction";
import ValidateRisk from "../Dashboard/ValidateRisk";
var existingFilter = [];
var existingFilterV1 = [];
var masterRiskList = [];
var selectedColumn = undefined;
var riskTypemaster = [];
var currentEditField = undefined;
var workstreamRole = undefined;
var persistenceRiskGridConst = [];
var heatmapCount=0;
export default function RiskDashboard(props) {
  const [persistenceRiskGrid, setPersistenceRiskGrid] = React.useState(PersistenceRisk);
  const [persistenceRiskGridTemp, setPersistenceRiskGridTemp] = React.useState(PersistenceRisk);

  const [persistenceActionGrid, setPersistenceActionGrid] = React.useState(ActionPersistence);
  const [title, setTitle] = React.useState("");
  const [editField, setEditField] = React.useState(undefined);
  const [excelImport, setOpenExcelImport] = React.useState(false);
  const [isRiskImport, setIsRiskImport] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [action, setAction] = React.useState(null);
  const [actionimpactcolumn, setactionimpactcolumn] = React.useState([]);
  const [currentChangedValue, setCurrentChangedValue] = React.useState({});
  const [stackeHolderList, setStackeHolderList] = React.useState([]);
  const [ownerListForRisk, setOwnerListForRisk] = React.useState([]);
  const [actionTypeListForRisk, setActionTypeListForRisk] = React.useState([]);
  const [openPdfTitlePopup, setOpenPdfTitlePopup] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [orgUnit, setOrgUnit] = React.useState({});
  const [addRiskBtnFlag, setAddRiskBtnFlag] = React.useState(true);
  const [viewMiti, viewMitigation] = React.useState(false);
  
  // const[actionGridFlag,setActionGridflag]=React.useState(true);
  const [sort, setSort] = React.useState([]);
  const [skip, setSkip] = React.useState(0);
  const [take, setTake] = React.useState(
    Math.round((window.innerHeight - 250) / 35)
  );
  const [openImpactRating, setOpenImpactRating] = React.useState(false);
  const [impactslist, setImpactslist] = React.useState([]);
  const [qualitativeImpactslist, setQualitativeImpactslist] = React.useState(
    []
  );
  const [weightageList, setWeightageList] = React.useState([]);
  const [fixedGrid, setFixedGrid] = React.useState(true);
  const [stickyClassVal, setStickClass] = React.useState("");
  const [riskAddBtnHideFlag, setRiskAddBtnHideFlag] = React.useState(true);
  const [riskAddOrEdit, setRiskAddOrEdit] = React.useState(false);
  const [riskCustomFieldSave, setRiskCustomFieldSave] = React.useState([]);
  const [probabilityRangeMaster, setProbabilityRangeMaster] = React.useState([]);
  const [probabilityColumns, setProbabilityColumns] = React.useState([]);

  const [formEditFlag,setFormEditFlag] = React.useState(false);
  const [showFormView,setShowFormView]= React.useState(false);
  const [formData,setFormData]= React.useState({});
  
  const [importRequest, setImportRequest] = React.useState();
  const [importFileName, setImportFileName] = React.useState(undefined);
  const [enable_errorlog,setenable_errorlog]= React.useState(false);
  const [isvalidatepopup,setIsvalidatepopup]= React.useState(false);
  const [errorDataList, setErrorDataList] = useState([]);
  const [dataUploadCount, setDataUploadCount] = useState({
    totalRow:0,
    failedRow:0,
    successRow:0
  });

  const [validateBtnFlag,SetValidateBtnFlag]= React.useState(false);
  const [excelTemplates,setExcelTemplates]=useState([]);
  const [excelTemplateValue,setExcelTemplatesValue]=useState(undefined);
  const pdfExportComponent = React.useRef(null);
  const [showGrid, setShowGrid] = useState(true);

  const [filter, setFilter] = React.useState({
    logic: "and",
    filters: [],
  });
  const filterOperators = {
    text: [
      { text: "grid.filterContainsOperator", operator: "contains" },
      { text: "grid.filterNotContainsOperator", operator: "doesnotcontain" },
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterStartsWithOperator", operator: "startswith" },
      { text: "grid.filterEndsWithOperator", operator: "endswith" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
    ],
    numeric: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterGteOperator", operator: "gte" },
      { text: "grid.filterGtOperator", operator: "gt" },
      { text: "grid.filterLteOperator", operator: "lte" },
      { text: "grid.filterLtOperator", operator: "lt" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    date: [
      { text: "grid.filterEqOperator", operator: "eq" },
      { text: "grid.filterNotEqOperator", operator: "neq" },
      { text: "grid.filterAfterOrEqualOperator", operator: "gte" },
      { text: "grid.filterAfterOperator", operator: "gt" },
      { text: "grid.filterBeforeOperator", operator: "lt" },
      { text: "grid.filterBeforeOrEqualOperator", operator: "lte" },
      { text: "grid.filterIsNullOperator", operator: "isnull" },
      { text: "grid.filterIsNotNullOperator", operator: "isnotnull" },
    ],
    boolean: [{ text: "grid.filterEqOperator", operator: "eq" }],
  };
  const myRef = useRef();

  var customFieldsData = [];
  var cellAddValue = "";

  const [dataState, setDataState] = React.useState({
    sort: [],
    take: 15,//Math.round((window.innerHeight - 250) / 35),
    skip: 0,
    group: [],
  });
  const [updatedfield,setUpdatedField]=React.useState(0);
 
  const [expandedRowList, setExpandRowList] = React.useState([]);
  const[probability_value ,setprobability_value]= React.useState([]);
  const reportWindowSize = () => {
    if (window.innerWidth > 768) {
      setFixedGrid(true);
      setStickClass("k-grid-content-sticky");
    } else {
      setFixedGrid(false);
      setStickClass("");
    }
  };

  window.addEventListener("resize", reportWindowSize);
  window.addEventListener("load", reportWindowSize);

  const handleOpenExportDialog = (flag) => {
    setOpenExcelImport(true);
    setIsRiskImport(flag);
    setImportRequest({});
    setImportFileName(undefined);
    SetValidateBtnFlag(false);
    setRiskValidationDataCount({
      newRiskCount:0,
      modifiedRiskCount:0,
      closedRiskCount:0
    });
    fetchPendingCommitForWorkstream(flag);
  };
  const [riskValidationDataCount,setRiskValidationDataCount]=React.useState({
    newRiskCount:0,
    modifiedRiskCount:0,
    closedRiskCount:0
  });
  const handleValidateDataCount=(obj)=>{
    setRiskValidationDataCount({
      newRiskCount:obj.newRiskCount,
      modifiedRiskCount:obj.modifiedRiskCount,
      closedRiskCount:obj.closedRiskCount
    });
  }
const [pendingCommitFlag,setPendingCommitFlag]=React.useState(false);
  const fetchPendingCommitForWorkstream = async (flag) => {
    try {
      setLoader(true);
      let request = {
        workstreamId: parseInt(props.match.params.organizationUnitId),
        excelUploadType: flag===true?"risk":"action"
      };
      let response = await Api.fetchPendingCommitForWorkstream(request);
      if (
        response.status === 200 &&
        response.pendingExcelUploader &&
        response.pendingExcelUploader.length > 0
      ) {
        if(flag===true&&response.pendingExcelUploader[0].excelUploadType==="risk"){
          setPendingCommitFlag(true);
        }else if(flag===false&&response.pendingExcelUploader[0].excelUploadType==="action"){
          setPendingCommitFlag(true);
        }
        setLoader(false);
      } else {
        setPendingCommitFlag(false);
        setLoader(false);
      }
    } catch (err) {}
  };

  const handleImportDialogClose = () => {
    setOpenExcelImport(false);
  };

  const ImpactRatingOpen = () => {
    setOpenImpactRating(true);
  };
  const ImpactRatingClose = () => {
    setOpenImpactRating(false);
  };

  const [riskCount, setRiskCount] = React.useState({});
  const [actionCount, setActionCount] = React.useState({});
  const [aggregationsCount, setAggregationsCount] = React.useState({});
  const getiskCount = async () => {
    try {
      // setLoader(true);
      var req = {
        orgId: parseInt(props.match.params.organizationUnitId),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        type: "Risk",
      };
      let response = await Api.getRiskCount(req);
      if (response.status === 200 && response.riskCountResponses) {
        // setLoader(false);
        setRiskCount(response.riskCountResponses);
        setActionCount(response.actionCountResponse);
        setAggregationsCount(response.aggregations);
      } else {
        setRiskCount({
          totalRiskCount: 0,
          openRiskCount: 0,
          activeRiskCount: 0,
          closedRiskCount: 0,
        });
        // setLoader(false);
      }
      // console.clear();
    } catch (error) {
      // setLoader(false);
      setRiskCount({
        totalRiskCount: 0,
        openRiskCount: 0,
        activeRiskCount: 0,
        closedRiskCount: 0,
      });
      console.error(error);
    }
  };
 
  const getImpactRatingTable = async () => {
    try {
      var req = {
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.getImpactRatingTable(req);
      if (response.status === 200 && response.impactRatingTable) {
        let wlist = response.impactRatios ? response.impactRatios : [];
        setWeightageList(wlist);
        
        dynamicColsQuantitative(response.impactRatingTable,response.probabilityRangeResponse);
        setImpactslist(response.impactRatingTable);

        dynamicColsQualititative(response.qualityimpactRatingTable,response.probabilityRangeResponse);
        setQualitativeImpactslist(response.qualityimpactRatingTable);

        let arr = response.probabilityRangeResponse;
        let rangeArray = [];
        let probabilityObj = {};
        let probabilityval = {};

        arr = arr?.map((item) => {
          item[item.fullDescription] = item.probabilityRangeValue;
          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <GridColumn
            key={index}
            field={column.fullDescription}
            title={column.fullDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));
        let array = response.probabilityRangeResponse;
        array = array?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;
          probabilityval = { ...probabilityval, ...item };
          return item;
        });
        let probabilityArray = array.map((column, index) => (
          <GridColumn
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={false}
          />
        ));

        setProbabilityRangeMaster([probabilityval]);
        setprobability_value(probabilityArray)
        setProbabilityColumns(rangeArray);

        
      } else {
        setImpactslist([]);
        setProbabilityRangeMaster([]);
        setWeightageList([]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const dynamicColsQuantitative = (data,probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.impactThresholdValue.map((item) => {
          let field = getFieldName(item.orderId,probabilityRangeResponse);
          res[field] = item.thresholdValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  const dynamicColsQualititative = (data,probabilityRangeResponse) => {
    try {
      data.map((res) => {
        res.qualitativeImpactValue.map((item) => {
          let field = getFieldName(item.orderId,probabilityRangeResponse);
          res[field] = item.qualitativeValue;
        });
      });
    } catch (error) {
      // this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
 const getFieldName = (orderId,probabilityRangeResponse) => {
   let obj = probabilityRangeResponse.find(
     (item) => item.orderId === orderId
   );
   return obj?.fullDescription;
 };
  
  const [HeatMapConfigDataOpportunity, setHeatMapConfigDataOpportunity] = React.useState([]);
  const [HeatMapConfigDataThreat, setHeatMapConfigDataThreat] = React.useState([]);
  const [dynamicHeatmapProbabilityRange, setDynamicHeatmapProbabilityRange] = React.useState([]);

  const getMatrixColorCodes = async () => {
    try {
      var req = {
        WorkstreamId: 0,
      };
      let response = await Api.MatrixColor(req);
      if (response.status === 200) {
        heatmapCount=response.heatmapCount;
        // normal,opportunity
       let normal_opp = response.matrixColor.find(
        (item) => item.riskType === "opportunity"
      );
      let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

      //  normal,threat
      let normal_threat = response.matrixColor.find(
        (item) => item.riskType === "threat"
      );
      let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
      setHeatMapConfigDataOpportunity(opp_colorJsonData);
      setHeatMapConfigDataThreat(threat_colorJsonData);
      setDynamicHeatmapProbabilityRange(response.dynamicHeatmapProbabilityRange);
      
      }
    } catch (error) {
      console.error(error);
    }
  };
  const [riskTypeList, setRiskTypeList] = React.useState([]);
  const [opportunitiesList, setOpportunitiesList] = React.useState([
    { text: "Threat", value: "Threat" },
    { text: "Opportunity", value: "Opportunity" },
  ]);
  const [customFieldsDataState, setCustomFieldsDataState] = React.useState([]);
  const gridRef = useRef(null);

  useEffect(() => {
    existingFilter = [];
    existingFilterV1 = [];
    masterRiskList = [];
    selectedColumn = undefined;
    riskTypemaster = [];
    currentEditField = undefined;
    isAuthorizeUse();
  }, []);
  


  const history = useHistory();
  const isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (props.match.params.id) {
        history.push({
          pathname: `/tenant/${props.match.params.id}`,
        });
      } else {
        history.push({
          pathname: "/",
        });
      }
    } else {
      setLoader(true);
      await getRiskTypeList();
      await nonAsynccallingMethods();
      await getPersistance();
      getPersistanceAction();
      let res = await getCustomField();
      customFieldsData = res;
      setCustomFieldsDataState(res);
      getAllTenantUserList();
      getAllOwnerList();
      getExcelTemplates();
      getActionTypeList();
      await getOrgUnitById();
      reportWindowSize();
      //show/hide cols methods
      // await createActionAndRiskColumns();
      await getColumnSettings("Risk");
      await getColumnSettings("Action");

      if (gridRef.current) {
        const gridColumns = gridRef.current.columns;
         gridColumns.map((item,i) => {
          item["orderIndex"] = i;
          return item;
        });
        console.log("gridColumns",gridColumns);
        setPersistenceRiskGridTemp(gridColumns);
      } 
    }
  };

  const nonAsynccallingMethods = () => {
     getMatrixColorCodes();
    getImpactRatingTable();
  };
  const getCustomField = async () => {
    let res = [];
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };

      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        response.customFields.map((item) => {
          item.cfPossibleValues.map((item1) => {
            item1["hashValue"] = convertStrToHash(item1.possibleValues);
          });
          if(item.inputType=="Single Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }else if(item.inputType=="Multi Drop Down"){
            let newFirstElement = {
              "hashValue":"",
              "id": 0,
              "possibleValues": " [blank]",
            }
           
            item["cfPossibleValues"] = [newFirstElement].concat(item.cfPossibleValues);
            item["possibleValues"]=[" [blank]"].concat(item.possibleValues);
          }
        });
        res = response.customFields;
      }
    } catch (err) {
      console.error("Exception:", err);
    }
    return res;
  };
  const getExcelTemplates = async () => {
    try {
      let response = await Api.getExcelTemplates();
      if (response.status === 200) {
        setExcelTemplates(response.excelTemplates)
      } 
    } catch (error) {
      console.error(error);
    }
  };
  const getRiskTypeList = async () => {
    var typeList = [];
    try {
      let response = await Api.getRiskType();
      if (response.status === 200 && response.riskTypes) {
        for (var i = 0; i < response.riskTypes.length; i++) {
          if (response.riskTypes[i].name && response.riskTypes[i].name != "") {
            typeList.push({
              value: response.riskTypes[i].riskTypeId,
              text: response.riskTypes[i].name,
              id: response.riskTypes[i].riskTypeId,
              name: response.riskTypes[i].name,
              checked: false,
              hashValue: convertStrToHash(response.riskTypes[i].name),
            });
          }
        }

        let newFirstElement = {
              value: "undefined",
              text: "undefined",
              id: 0,
              name: " [blank]",
              checked: false,
              hashValue: "undefined",
        }
        typeList = [newFirstElement].concat(typeList);
        setRiskTypeList([...typeList]);
        riskTypemaster = [...typeList];
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getOrgUnitById = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var req = {
        UnitId: parseInt(props.match.params.organizationUnitId),
        CreatedBy: parseInt(createdby),
        IsTasksModule:false
      };
      let response = await Api.getOrgUnitById(req);
      if (
        response.status === 200 &&
        response.orgUnitProjectResponses &&
        response.orgUnitProjectResponses.length > 0
      ) {
        setOrgUnit(response.orgUnitProjectResponses[0]);
        workstreamRole = response.orgUnitProjectResponses[0].role;
        let cfArray=response.orgUnitProjectResponses[0].customFields;
        createActionAndRiskColumns(cfArray);
        await getRiskRegistorList();
      } else {
        setOrgUnit({});
        setLoader(false);
        createActionAndRiskColumns([]);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      createActionAndRiskColumns([]);
    }
  };

  
  const [actionsColumnFields,setActionsColumnFields]=useState([]);
  const [risksColumnFields,setRisksColumnFields]=useState([]);
  const [selectedActionsColumnFields,setselectedActionsColumnFields]=useState([]);
  const [selectedRisksColumnFields,setselectedRisksColumnFields]=useState([]);
  
  const handleSelectedRisksColumnFields = (e) => {
    setselectedRisksColumnFields(e.target.value);
    setPersistenceRiskGrid(PersistenceRisk);
    setShowGrid(false); // Unmount the grid
    setTimeout(() => {
      setShowGrid(true); // Remount the grid
    }, 100);
    onColumnReorder(null);
  };

  const handleSelectedActionsColumnFields=(e)=>{
    setselectedActionsColumnFields(e.target.value);
    setPersistenceActionGrid(ActionPersistence);
    let req = {
      ActionDetails: undefined,
      WorkstreamId: parseInt(props.match.params.organizationUnitId),
      UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      CreatedDate: new Date(),
      updatedDate: new Date(),
    };
    Api.persistAction(req);
  }
  
  const saveColumnSettings = async (e,flag) => {
    try {
      let req = {
        ColumnDetails: JSON.stringify(e.target.value),
        ColumnType: flag,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };
      await Api.saveColumnSettings(req);
    } catch (error) {
      console.error(error);
    }
  };
  const getColumnSettings = async (flag) => {
    try {
      setLoader(true);
      let req = {
        ColumnType: flag,
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.getColumnSettings(req);
      if (response.status === 200&&response.columnSettings&&response.columnSettings.columnDetails!="[]") {
        let columnDetails=JSON.parse(response.columnSettings.columnDetails);
        if (response.columnSettings.columnType === "Action") {
          setselectedActionsColumnFields(columnDetails);
        } else if (response.columnSettings.columnType === "Risk") {
          setselectedRisksColumnFields(columnDetails);
        }
        setLoader(false);
      } else {
        if (flag === "Action") {
          setselectedActionsColumnFields([]);
        } else if (flag === "Risk") {
          setselectedRisksColumnFields([]);
        }
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };
  const isHiddenRiskColumn=(field)=>{
    return selectedRisksColumnFields.some((item)=>item.fieldName===field);
  }

  const createActionAndRiskColumns=(cfArray)=>{
    try{
      let riskCols=[];
      let actionCols=[];
      //Risk
      PersistenceRisk.map((item) => {
        if (item.field != "customFields" &&
            item.field != "impactFields" &&
            item.field != "riskTitle" &&
            item.field != "isOpportunity" &&
            item.field != "pre" &&
            item.field != "current" &&
            item.field != "post" &&
            item.field != "number"
          ) {
          riskCols.push({
            fieldName: item.field,
            displayName: item.title,
          });
        }
      });
      //Action
      ActionPersistence.map((item) => {
        if (item.field != "ImpactFields"&&item.field != "name"&&item.field != "number") {
          actionCols.push({
            fieldName: item.field,
            displayName: item.title,
          });
        }
      });
      cfArray.map((item)=>{
        riskCols.push({
          fieldName: item.fieldName,
          displayName: item.fieldName,
        });
      });
      riskCols.sort((a, b) => a.displayName.localeCompare(b.displayName));
      actionCols.sort((a, b) => a.displayName.localeCompare(b.displayName));
      setRisksColumnFields(riskCols);
      setActionsColumnFields(actionCols);
    }catch (error) {
      console.error(error);
    }
  }

  const actionImpactList = async (products) => {
    var impactMaster = [];
    if (products && products.length > 0) {
      impactMaster = products[0].impactResponse;
    }
    var impactColumn = [];

    products.map((res) => {
      // res["isOpen"]=res.isOpen?"Open":"Close";
      // res["approved"]=res.approved?"Yes":"No";
      res.impactResponse &&
        res.impactResponse.map((item) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
    });
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse && res.impactResponse.find((item) => item.name === col);
          if (temp) {
            res[col] =
              temp.impactType == "Quantitative" ? temp.value : temp.qValue;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    var columnsToShow = [];

    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <ExcelExportColumn
          field={item}
          title={"Reduction" + getActionImpactUnit(item, impactMaster)}
        />
      ));
    }
    setactionimpactcolumn(columnsToShow);
  };
  const getActionImpactUnit = (impact, impactMaster) => {
    var res = impact;
    var impactTemp = impactMaster.find((item) => item.name == impact);

    if (impactTemp && impactTemp.name) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };

  const getAllTenantUserList = async () => {
    try {
      let response = await Api.getuserAddedByTenant();
      if (response.status === 200 && response.tenantUsers) {
        var typeList = [];
        var tempUserList = [];
        let stackeHolderList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
          });
          typeList.push(response.tenantUsers[i].name);
          stackeHolderList.push({
            userId: response.tenantUsers[i].userId,
            displayName:
              response.tenantUsers[i].name +
              " (" +
              response.tenantUsers[i].emailAddress +
              ")",
            email: response.tenantUsers[i].emailAddress,
          });
        }
       
        setStackeHolderList(stackeHolderList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };

  const getAllOwnerList = async () => {
    try {
      let req = {
        orgId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.getAllOwnerrList(req);
      if (response.status === 200 && response.users) {
        var tempUserList = [];

        for (var i = 0; i < response.users.length; i++) {
          tempUserList.push({
            value: response.users[i].userId,
            text: response.users[i].userName,
          });
        }
        let newFirstElement={
            value: null,
            text: " [blank]",
        }
        tempUserList=[newFirstElement].concat(tempUserList);
        setOwnerListForRisk(tempUserList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };
  const getActionTypeList = async () => {
    try {
      let req = {
        orgId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.getProjectStage(req);
      if (response.status === 200 && response.actionTypes) {
        var tempActionTypeList = [];

        for (var i = 0; i < response.actionTypes.length; i++) {
          tempActionTypeList.push({
            value: response.actionTypes[i].actionId,
            text: response.actionTypes[i].name,
          });
        }
          let newFirstElement={
            value: null,
            text: " [blank]",
          }
        tempActionTypeList=[newFirstElement].concat(tempActionTypeList);
        setActionTypeListForRisk(tempActionTypeList);
      }
    } catch (error) {
      setLoader(false);

      console.error(error);
    }
  };
  const manageCustomValues = async (updateDate) => {
    let type = getInputType(updateDate.inEdit);
    if ((type && type === "Multi Drop Down") || type === "Single Drop Down") {
      updateRiskRegistor(updateDate, false);
    } else {
      let dirtData = masterRiskList.find(
        (item) => updateDate.riskRegisterId == item.riskRegisterId
      );
      if (
        dirtData &&
        updateDate[updateDate.inEdit] == dirtData[updateDate.inEdit]
      ) {
        exitEdit();
        return;
      } else {
        updateRiskRegistor(updateDate, false);
      }
    }
  };

  // var riskCustomFieldSave=[];//

  const [dropdownColumns, setDropdownColumns] = React.useState([]);
  //Custom fields
  const createDynamicDropdowns = (products, filter) => {
    let dropdownColumn = [];
    products.map((res) => {
      res.customFields&&res.customFields.map((item) => {
        if (dropdownColumn.length > 0) {
          if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
            dropdownColumn.push({
              fieldName: item.fieldName,
              data: getCustomFieldMasterData(item.fieldName, filter),
              inputType: getInputType(item.fieldName),
            });
          }
        } else {
          dropdownColumn.push({
            fieldName: item.fieldName,
            data: getCustomFieldMasterData(item.fieldName, filter),
            inputType: getInputType(item.fieldName),
          });
        }
      });
    });
    console.log("dropdownColumn",dropdownColumn)
    if (dropdownColumn.length > 0) {
      products.map((res) => {
        dropdownColumn.map((col) => {
          let temp = res.customFields&&res.customFields.find(
            (item) => item.fieldName === col.fieldName
          );
          if (temp) {
            if (temp.inputType === "Multi Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              let hashArr = stringToHashForCF(val, col.data);
              res[col.fieldName] = hashArr;
            } else if (temp.inputType === "Single Drop Down") {
              let val = temp.selectedCustomFieldNames
                ? temp.selectedCustomFieldNames.toString()
                : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Free Text") {
              let val = temp.multiText;
              res[col.fieldName] = val;
            } else if (temp.inputType === "Numeric") {
              let val = temp.multiText ;//? parseInt(temp.multiText) : "";
              res[col.fieldName] = val;
            } else if (temp.inputType === "Date") {
              let val = temp.multiText ? new Date(temp.multiText) : undefined;
              res[col.fieldName] = val;
            }
          } else {
            res[col.fieldName] = "NA";
          }
        });
      });
    }
    console.log("res",products)

    let columnsToShow = [];
    if (dropdownColumn.length > 0) {
      columnsToShow = dropdownColumn.map((item) => (
        <GridColumn
          field={item.fieldName}
          title={item.fieldName}
          resizable={true}
          reorderable={true}
          // width={getFieldWidth(item.fieldName)}
          width={"200px"}
          cell={(props) => getCustomFieldComponent(props, products, item)}
          columnMenu={(props) => getCustomFieldColumnMenu(props, item)}
          filter={getCustomFieldFilter(item)}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setDropdownColumns(columnsToShow);
  };

  const getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };
  const getcustomfieldfilterlist=(list)=>{
    var sorted_arr =  list.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return sorted_arr
  }

  const getCustomFieldColumnMenu = (props, item) => {
    console.log("data data",masterRiskList);
    if (item.inputType === "Multi Drop Down") {
      getcustomfieldfilterlist(item.data);
      return (
        <CustomFieldSearchMenu
          {...props}
          customFieldsmaster={item.data}
          existingFilter={existingFilter ? existingFilter : existingFilterV1}
          filterChangeV={filterChangeV}
          clearFilter={clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={masterRiskList}
          getSelectedColumn={getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
      );
    }
  };

  const getFieldWidth = (cellFieldName) => {
    let width = "200px";
    let res = persistenceRiskGridConst.find(
      (item) => item.field === cellFieldName
    );
    if (res) {
      width = res.width;
    }
    return width;
  };

  const getCustomFieldComponent = (props, products, cfObj) => {
    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return (
        <RiskCustomFieldDropdownCell
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <RiskCustomFieldSingleDropdownCell
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <RiskCustomFieldFreeText
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <RiskCustomFieldNumeric
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <RiskCustomFieldDate
          {...props}
          onEditCell={customCellEdit}
          stateData={products}
          manageCustomValues={manageCustomValues}
          // manageCustomValuesSave={manageCustomValuesSave}
          customFieldsData={
            customFieldsData.length > 0
              ? customFieldsData
              : customFieldsDataState
          }
        />
      );
    } else {
      return <td></td>;
    }
  };

  const getInputType = (fieldName) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.find((item) => item.fieldName == fieldName);
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCustomFieldMasterData = (fieldName, filter) => {
    try {
      if (customFieldsData.length == 0) {
        customFieldsData = customFieldsDataState;
      }
      let arr = customFieldsData.filter((item) => item.fieldName == fieldName);
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked = checkCFinFilterValuesOrNot(
            fieldName,
            item.hashValue,
            filter
          );
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };
  const [impactColumns, setImpactColumns] = React.useState([]);
  //Imapcts
  const createDynamicCols = async (products, impactMasterTemp, filter) => {
    let impactColumn = [];
    products.map((res) => {
      res.impactResponse && res.impactResponse.map((item) => {
        if (impactColumn.length > 0) {
          if (!impactColumn.find((cf) => cf.fieldName == item.fieldName)) {
            impactColumn.push({
              fieldName: item.name + "_" + item.type,
              impactType: item.impactType,
            });
          }
        } else {
          impactColumn.push({
            fieldName: item.name + "_" + item.type,
            impactType: item.impactType,
          });
        }
        // }
      });
    });

    impactColumn = impactColumn.filter(
      (ele, ind) =>
        ind ===
        impactColumn.findIndex(
          (elem) =>
            elem.fieldName === ele.fieldName &&
            elem.impactType === ele.impactType
        )
    );
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          if (col.impactType == "Qualitative") {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postQvalue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] =temp.qValue;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] =temp.currentQvalue;
            } else {
              res[col.fieldName] = 0;
            }
          } else {
            let temp = res.impactResponse && res.impactResponse.find(
              (item) => item.name + "_" + item.type === col.fieldName
            );
            if (temp&&temp.type == "Post") {
              res[col.fieldName] =  temp.postImpactValue;
            }else if (temp&&temp.type == "Pre"){
              res[col.fieldName] = temp.value;
            }else if (temp&&temp.type == "Current"){
              res[col.fieldName] = temp.currentImpactValue;
            } else {
              res[col.fieldName] = 0;
            }
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <GridColumn
          filter={"numeric"}
          field={item.fieldName}
          resizable={true}
          reorderable={true}
          title={getImpactUnit(item, impactMasterTemp)}
          // width={getFieldWidth(item.fieldName)}
          width={"200px"}
          cell={(props) => getImpactCellComponent(props, products, item)}
          editable={true}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={checkItsinFilterOrNot(item.fieldName, filter)}
        />
      ));
    }
    setImpactColumns(columnsToShow);
  };

  const setClassName = (field) => {
    let headerClassName = "";
    if (filter && filter.filters) {
      filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };

  const checkItsinFilterOrNot = (field, exfilter) => {
    try {
      let headerClassName = "";
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = "active";
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = "active";
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {}
  };

  const checkRisktypeSelections = (exfilter) => {
    let temp = [];
    riskTypemaster.map((item) => {
      let checked = checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    setRiskTypeList([...temp]);
    riskTypemaster = [...temp];
  };
  const checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };
  const getImpactCellComponent = (props, products, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={numericCellEdit}
          stateData={products}
          addQualitativeImpact={AddQualitativeImpact}
          heatMapCount={heatmapCount}
        />
      );
    } else {
      return (
        <ImpactEditComponent
          {...props}
          onEditCell={numericCellEdit}
          stateData={products}
        />
      );
    }
  };

  const getImpactUnit = (impact, impactMasterTemp) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = impactMasterTemp.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
      var impactTemp = impactMasterTemp.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res =
          impactTemp.name +
          " / " +
          impactTemp.units +
          " (" +
          impactTemp.type +
          ")";
      }
      return res;
    }
  };

  const getRiskRegistorList = async () => {
    try {
      setLoader(true);
      setAddRiskBtnFlag(true);
      var request = {
        OrgUnitIds: [parseInt(props.match.params.organizationUnitId)],
      };
      let response = await Api.getRiskForOrgUnit(request);

      if (response.status === 200 && response.riskRegister) {
        currentEditField = undefined;
        response.riskRegister.map((riskReg) => {
          if (expandedRowList.includes(riskReg.riskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.updatedDate) {
            // riskReg.updatedDate = new Date(riskReg.updatedDate);
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            var time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          if (workstreamRole) {
            riskReg["role"] = workstreamRole;
          }

          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNamesExport"] = riskReg.riskTypeNames.toString();
            let hashArr = stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );

            riskReg["riskTypeNames"] = hashArr;
          }else{
            riskReg["riskTypeNames"] = "undefined";
            riskReg["riskTypeNamesExport"]="";
          }
          if (riskReg.riskAlertStakeHolders) {
            riskReg["riskAlertStakeHolders"] =
              riskReg["riskAlertStakeHolders"].toString();
          }
          if (!riskReg.progress) {
            riskReg["progress"] = "";
          }
          let str = "";
          if (riskReg.riskImpactComments) {
            riskReg.riskImpactComments.map((cmt) => {
              str +=
                " Name:" +
                cmt.userName +
                "\n Date:" +
                moment(new Date(cmt.createdDate)).format(
                  "DD-MMM-yyyy HH:mm:ss"
                ) +
                "\n Comments: " +
                cmt.riskComment +
                "\r\n";
            });
            riskReg["progressHistory"] = str;
          } else {
            riskReg["progressHistory"] = null;
          }
          // riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
          if (riskReg.isClosed) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
        });

        let impactMasterTemp = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMasterTemp = response.riskRegister[0].impactResponse;
        }
        let filter = existingFilter ? existingFilter : [];
        await createDynamicCols(response.riskRegister, impactMasterTemp, filter);
        await createDynamicDropdowns(response.riskRegister, filter);
        await checkRisktypeSelections(filter);
        const result = filterBy(response.riskRegister, filter);
      
        getiskCount();
        setData(result);
        setAction(constructMitigationReps(result));
        masterRiskList = response.riskRegister;
        setLoader(false);
      } else {
        setData([]);
        getiskCount();
        setLoader(false);
        masterRiskList=[];
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      masterRiskList=[];
      setData([]);
      getiskCount();
    }
  };

  const constructMitigationReps = (riskRegister) => {
    var mitigationRespsArray = [];
    let ind = 0;
    riskRegister.map((reg) => {
      if (reg.mitigationResps && reg.mitigationResps.length > 0) {
        for (let mitigationResps in reg.mitigationResps) {
          let actionObj = reg.mitigationResps[mitigationResps];
          if (actionObj.actualCompletionDate) {
            actionObj.actualCompletionDate = new Date(
              actionObj.actualCompletionDate
            );
          }
          if (actionObj.originalCompletionDate) {
            actionObj.originalCompletionDate = new Date(
              actionObj.originalCompletionDate
            );
          }
          if (actionObj.projectedCompletionDate) {
            actionObj.projectedCompletionDate = new Date(
              actionObj.projectedCompletionDate
            ); 
          }
          if (actionObj.proximityDate) {
            actionObj.proximityDate = new Date(actionObj.proximityDate);
          }
          if (actionObj.updatedDate) {
            actionObj.updatedDate = new Date(actionObj.updatedDate);
          }
          if (actionObj.createdDate) {
            actionObj.createdDate = new Date(
              actionObj.createdDate
            );
          }
          let str = "";
          if (actionObj.actionImpactComments) {
            actionObj.actionImpactComments.map((cmt) => {
              str +=
                " Name:" +
                cmt.userName +
                "\n Date:" +
                moment(new Date(cmt.createdDate)).format(
                  "DD-MMM-yyyy HH:mm:ss"
                ) +
                "\n Comments: " +
                cmt.actionComment +
                "\r\n";
            });
            actionObj["progressHistory"] = str;
          } else {
            actionObj["progressHistory"] = null;
          }
          
          // actionObj.approved = actionObj.approved ? "Yes" : "No";
          // actionObj.isOpen = actionObj.isOpen ? "Open" : "Closed";
          if(actionObj.approved===true||actionObj.approved==="Yes"){
            actionObj["approved"] ="Yes";
          }else{
            actionObj["approved"] ="No";
          }
          if(actionObj.isOpen===true||actionObj.isOpen==="Open"){
            actionObj["isOpen"]="Open";
          }else{
            actionObj["isOpen"]="Closed";
          }
          // mitigationRespsArray[ind++] = actionObj;
          mitigationRespsArray.push(actionObj);
        }
      }
    });

    actionImpactList(mitigationRespsArray);
    return mitigationRespsArray;
  };
  const riskRegistorUpdateValidation = async (Value) => {
    var flag = true;
    var msg = "";

    if (!Value.riskTitle || Value.riskTitle.trim() == "") {
      flag = false;
      msg = "The risk title";
    }

    if (!Value.isOpportunity) {
      flag = false;
      msg = msg + " and threat/opportunity";
    }

    if (!flag) {
      toastr.error(msg + " are required");
    }
    return flag;
  };
  const riskRegistorValidation = async () => {
    var flag = true;
    var msg = "";

    if (
      !currentChangedValue.riskTitle ||
      currentChangedValue.riskTitle.trim() == ""
    ) {
      flag = false;
      msg = "Risk title";
    }

    if (
      !currentChangedValue.isOpportunityText &&
      !currentChangedValue.isOpportunity
    ) {
      flag = false;
      msg = msg + ",Threat/Opportunity";
    }

    if (!flag) {
      toastr.error(msg + " is required.");
    }
    return flag;
  };
  const saveRiskRegistor = async () => {
    try {
      var flag = await riskRegistorValidation();

      if (!flag) {
        return;
      }
      setRiskAddBtnHideFlag(false);
      // setLoader(true);

      var freq = currentChangedValue.frequency
        ? parseInt(currentChangedValue.frequency)
        : 0;
      if (currentChangedValue.proximityDate) {
        currentChangedValue.proximityDate = currentChangedValue.proximityDate
          ? moment(currentChangedValue.proximityDate).format("YYYY-MM-DD")
          : null;
      }

      let riskTypeIds = [];
      if (
        currentChangedValue.riskTypeNames &&
        typeof currentChangedValue.riskTypeNames == "object"
      ) {
        currentChangedValue.riskTypeNames.map((id) => {
          let pid = riskTypeList.find((item) => item.text === id);
          riskTypeIds.push(pid.value);
        });
      } else {
        if (currentChangedValue.riskTypeNames) {
          let arr = currentChangedValue.riskTypeNames.toString().split(",");
          arr.map((item1) => {
            let pid = riskTypeList.find((item) => item.hashValue === item1);
            riskTypeIds.push(pid.value);
          });
        }
      }

      var requestParams = {
        OrganizationUnitId: parseInt(props.match.params.organizationUnitId),

        riskTypeIds: riskTypeIds,
        Number: "TEST-NO-000",
        Name: data[0].name ? data[0].name : currentChangedValue.name,

        Cause: data[0].cause ? data[0].cause : currentChangedValue.cause,
        ExistingControl: data[0].existingControl
          ? data[0].existingControl
          : currentChangedValue.existingControl,
        Frequency: data[0].frequency ? parseInt(data[0].frequency) : freq,
        ImpactComments: currentChangedValue.impactComments,
        ProximityDate: currentChangedValue.proximityDate,
        alertDescription: currentChangedValue.alertDescription,
        IsOpportunity: currentChangedValue.isOpportunityValue
          ? currentChangedValue.isOpportunityValue
          : currentChangedValue.isOpportunity
          ? currentChangedValue.isOpportunity
          : "Threat",
        IsClosed: currentChangedValue.isClosed
          ? currentChangedValue.isClosed
          : true,
        Owner: currentChangedValue.owner,
        riskTitle: currentChangedValue.riskTitle
          ? currentChangedValue.riskTitle.slice(0, 30)
          : "",
        riskAlertStakeHolders: currentChangedValue.riskAlertStakeHolders,
        riskCustomField: riskCustomFieldSave,
      };
      let response = await Api.addRiskRegister(requestParams);
      if (response.status === 200) {
        refreshRisk();
        toastr.success(response.message);
        setAddRiskBtnFlag(true);
        setCurrentChangedValue({});
        setRiskAddOrEdit(false);
      } else {
        toastr.error(response.message);
        setAddRiskBtnFlag(false);
        setRiskAddBtnHideFlag(true);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      setRiskAddBtnHideFlag(true);
    }
  };

  const refreshRisk = async (response, flag, riskRegisterId) => {
    setLoader(true);
    if (customFieldsData.length == 0) {
      let res = await getCustomField();
      customFieldsData = res;
      setCustomFieldsDataState(res);
    } else if (riskTypemaster.length == 0) {
      await getRiskTypeList();
    }

    if (flag == "update") {
      await refreshRiskForUpdate(response, riskRegisterId);
    } else {
      getRiskRegistorList();
    }

    // clearFilter();
  };
  const processInput=(input) =>{
    if (typeof input === "string") {
      return input.split(",").map((item) => item.trim()); // Optional: trim spaces around items
    } else if (Array.isArray(input)) {
      return input;
    } else {
      return [];
    }
  }
  const updateRiskRegistor = async (updateDate, flag) => {
    try {
      setLoader(true);
      if (flag) {
        var flag = await riskRegistorUpdateValidation(updateDate);

        if (!flag) {
          setLoader(false);
          return;
        }
      }

      if (updateDate.proximityDate) {
        updateDate.proximityDate = updateDate.proximityDate
          ? moment(updateDate.proximityDate).format("YYYY-MM-DD")
          : null;
      }

      let riskTypeIds = [];
      if (updateDate.riskTypeNames && currentEditField == "riskTypeNames") {
        let arr = updateDate.riskTypeNames.toString().trim().split(",");
        arr.map((id) => {
          let pid = riskTypeList.find((item) => item.text === id);
          if (pid) {
            riskTypeIds.push(pid.value);
          }
        });
      } else {
        let obj = masterRiskList.find(
          (item) => item.riskRegisterId == updateDate.riskRegisterId
        );
        if (obj) {
          riskTypeIds = obj.riskTypeIds;
        }
      }
      setAddRiskBtnFlag(true);
      var requestParams = {
        riskRegisterId: updateDate.riskRegisterId,
        organizationUnitId: parseInt(props.match.params.organizationUnitId),
        number: updateDate.number,
        name: updateDate.name,
        isOpportunity: updateDate.isOpportunityText
          ? updateDate.isOpportunityText
          : updateDate.isOpportunity,
        cause: updateDate.cause,
        existingControl: updateDate.existingControl,
        frequency: updateDate.frequency ? parseInt(updateDate.frequency) : 0,
        impactComments: updateDate.impactComments,
        progress: editField == "progress" ? updateDate.progress : null,
        proximityDate: updateDate.proximityDate,
        alertDescription: updateDate.alertDescription,
        isClosed://updateDate.isClosed,
          typeof updateDate.isClosed == "boolean"
            ? updateDate.isClosed
            : updateDate.isClosed == "Closed"
            ? false
            : true,
        owner: updateDate.owner===" [blank]"?null:updateDate.owner,
        userId: updateDate.owner===" [blank]"?null:updateDate.ownerId,
        riskTitle: updateDate.riskTitle
          ? updateDate.riskTitle.slice(0, 30)
          : "",
        riskAlertStakeHolders: processInput(updateDate.riskAlertStakeHolders),
        riskCustomField: [updateDate.riskCustomField],
        riskTypeIds: riskTypeIds,
        currentEditField: editField ? editField : currentEditField,
        currentProbability: updateDate.currentProbability,
      };

      let response = await Api.updateRiskRegister(requestParams);
      if (response.status === 200) {
        
        var res = masterRiskList.map((obj) => {
          if (obj && obj.riskRegisterId == updateDate.riskRegisterId) {

            obj = response.riskReg;
          }
          return obj;
        });
        setUpdatedField(updateDate.riskRegisterId);
        refreshRisk(res, "update", updateDate.riskRegisterId);
        setCurrentChangedValue({});
      } else {
        refreshRisk();
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  };
  const refreshRiskForUpdate = async (riskRegister, riskRegisterId) => {
    try {
      if (riskRegister) {
        currentEditField = undefined;
        riskRegister.map((riskReg) => {
          if (expandedRowList.includes(riskReg.riskRegisterId)) {
            riskReg["expanded"] = true;
          } else {
            riskReg["expanded"] = false;
          }
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.updatedDate) {
            // riskReg.updatedDate = new Date(riskReg.updatedDate);
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            var time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate
              ? new Date(closedDate)
              : "";
          }
          if (workstreamRole) {
            riskReg["role"] = workstreamRole;
          }

          if (
            riskReg.riskTypeNames &&
            riskReg.riskRegisterId === riskRegisterId
          ) {
            riskReg["riskTypeNamesExport"] = riskReg.riskTypeNames.toString();
            let hashArr = stringToHash(
              riskReg.riskTypeNames.toString(),
              "riskTypeNames"
            );
            riskReg["riskTypeNames"] = hashArr;
          }
          let str = "";
          if (riskReg.riskImpactComments) {
            riskReg.riskImpactComments.map((cmt) => {
              str +=
                " Name:" +
                cmt.userName +
                "\n Date:" +
                moment(new Date(cmt.createdDate)).format(
                  "DD-MMM-yyyy HH:mm:ss"
                ) +
                "\n Comments: " +
                cmt.riskComment +
                "\r\n";
            });
            riskReg["progressHistory"] = str;
          } else {
            riskReg["progressHistory"] = null;
          }
          if (riskReg.isClosed==true||riskReg.isClosed== "Open") {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
        });

        let impactMasterTemp = [];
        if (riskRegister && riskRegister.length > 0) {
          impactMasterTemp = riskRegister[0].impactResponse;
        }
        let filter = existingFilter ? existingFilter : [];
        await createDynamicDropdowns(riskRegister, filter);
        await createDynamicCols(riskRegister, impactMasterTemp, filter);
        const result = filterBy(riskRegister, filter);
        await checkRisktypeSelections(filter);

        setData(result);
       
        setAction(constructMitigationReps(result));

        getiskCount();
        masterRiskList = riskRegister;
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const openRiskFormView=()=>{
    setShowFormView(true);
  }

  const closeRiskFormView=()=>{
    setShowFormView(false);
    setFormEditFlag(false);
    setFormData({});
  }

  const addRiskDataFromForm=(flag,formData)=>{
    try{
      if(flag==="UPDATE"){
        var res = masterRiskList.map((obj) => {
          if (obj && obj.riskRegisterId == formData.riskRegisterId) {
  
            obj = formData;
          }
          return obj;
        });
        setUpdatedField(formData.riskRegisterId);
        refreshRisk(res, "update", formData.riskRegisterId);
        setCurrentChangedValue({});
      }else if(flag==="ADD"){
         masterRiskList.unshift(formData);
       // setUpdatedField(formData.riskRegisterId);
        refreshRisk(masterRiskList, "update", formData.riskRegisterId);
        //setCurrentChangedValue({});
      }
      
    }catch(err){
      console.error(err);
    }
  }

  const numericCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);

      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      }
      createDynamicCols(result, impactMasterTemp, filter);
      createDynamicDropdowns(result, filter);
      checkRisktypeSelections(filter);
      setData(dataValue);
      setEditField(field);
      setCurrentChangedValue(dataItem);
      setAction(constructMitigationReps(result));
    } catch (err) {}
  };
  const customCellEdit = (dataItem, field, riskData) => {
    try {
      let filter = existingFilter ? existingFilter : [];
      const result = filterBy(riskData, filter);
      const dataValue = result.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      }
      createDynamicCols(result, impactMasterTemp, filter);
      createDynamicDropdowns(result, filter);
      checkRisktypeSelections(filter);
      setData(dataValue);
      setEditField(field);
      setCurrentChangedValue(dataItem);
      setAction(constructMitigationReps(result));
    } catch (err) {}
  };

  const enterEdit = (dataItem, field) => {
    try {
      const dataValue = data.map((item) => ({
        ...item,
        inEdit:
          item.riskRegisterId === dataItem.riskRegisterId ? field : undefined,
      }));
      currentEditField = field;
      setData(dataValue);
      setEditField(field);
      setCurrentChangedValue(dataItem);
    } catch (err) {}
  };

  const exitEdit = () => {
    const dataValue = data.map((item) => ({ ...item, inEdit: undefined }));
    currentEditField = undefined;
    setData(dataValue);
    setEditField(undefined);
  };

  const cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];
    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              enterEdit(dataItem, cellField);
            },
            onFocus: () => {
              enterEdit(dataItem, cellField);
            },
            tabIndex: "0",
          };
        
    if (tdElement && tdElement.props ) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps ,},
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  const rowRender = (trElement,props) => {
     const RiskrowId =updatedfield;
    const bgcolor={
      backgroundColor:"rgba(0, 255, 76, 0.308)",
    }
      const trProps = {
      ...trElement.props,
      style: RiskrowId==props.dataItem.riskRegisterId  ? bgcolor:null,
      
   
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        currentEditField = editField;
        if (
          !editField ||
          editField == "riskAlertStakeHolders" ||
          editField == "progress" ||
          editField == "riskTypeNames"
        ) {
          return;
        }

        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            exitEdit();
          });
        }
        //dirty check
        let dirtData = masterRiskList.find(
          (item) => currentChangedValue.riskRegisterId == item.riskRegisterId
        );
        if (dirtData && currentChangedValue[editField] == dirtData[editField]) {
          exitEdit();
          return;
        }
        if (currentChangedValue.riskRegisterId) {
          if (!isImpactColumns(editField)) {
            var impact = currentChangedValue.impactResponse.find(
              (item) => item.name + "_" + item.type == editField
            );
            if (impact && impact.impactType != "Qualitative") {
              var req = {
                ProjectRiskId: currentChangedValue.riskRegisterId,
                ImpactId: impact.impactId,
                Value: parseFloat(currentChangedValue[editField]),
              };

              saveRiskImpact(req);
            }
            // else{
            //   var impact = currentChangedValue.impactResponse.find(
            //     (item) => item.name  == editField
            //   )
            //   if(impact){
            //     var request = {
            //       RiskId: currentChangedValue.riskRegisterId,
            //       QualitativeImpactId: impact.projectRiskImpactId,
            //       Qvalue: parseFloat(currentChangedValue[editField]),
            //     };
            //      AddQualitativeImpact(request);
            //   }

            // }
          } else {
            if (
              editField != "frequency" &&
              editField != "name" &&
              editField != "riskTitle" &&
              editField != "cause" &&
              editField != "existingControl" &&
              editField != "proximityDate" &&
              editField != "impactComments" &&
              editField != "alertDescription" &&
              editField != "riskAlertStakeHolders" &&
              editField == "progress"
            ) {
              updateRiskRegistor(currentChangedValue, true);
            }
          }
        } else {
          //Create
          var tmp = data;
          if (
            editField === "frequency" ||
            editField === "name" ||
            editField === "riskTitle" ||
            editField === "cause" ||
            editField === "existingControl" ||
            editField === "impactComments" ||
            editField === "alertDescription" ||
            editField === "riskAlertStakeHolders"
          ) {
            tmp[0][editField] =
              cellAddValue != "" ? cellAddValue : tmp[0][editField];
          }
          setData(tmp);
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },

   
    };
   
    return React.cloneElement(
      trElement,
      {
        ...trProps,
      },
    
      trElement.props.children
    );
  };

  const isImpactColumns = (field) => {
    return RiskColumns.hasOwnProperty(field);
  };

  const saveRiskImpact = async (req) => {
    try {
      setLoader(true);
      let response = await Api.addImpactByRisk(req);

      if (response.status === 200) {

        setUpdatedField(req.ProjectRiskId);
        refreshRisk();
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const AddQualitativeImpact = async (req) => {
    try {
      setLoader(true);
      var impact =
        (await req.impactResponse) &&
        req.impactResponse.find(
          (item) => item.name + "_" + item.type == req.inEdit
        );
      var request = {
        RiskId: req.riskRegisterId,
        QualitativeImpactId: impact ? impact.qualitativeImpactId : 0,
        Qvalue: req[req.inEdit], //req[req.inEdit]=="[blank]"?0:req[req.inEdit],
      };
      let response = await Api.addQualitativeImpact(request);
      if (response.status === 200) {
        console.log(request)
        // toastr.success(response.message);
        setUpdatedField( req.riskRegisterId);   
        refreshRisk();
      } else {
        setLoader(false);
        toastr.success(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const itemChange = async (event) => {
    let changedValue;
    let dataValue;

    if (event.field === "riskTypeNames") {
      let value = event.value;
      changedValue = {
        ...event.dataItem,
        riskTypeNames: value,
        // riskTypeId: event.value.value,
      };
      let str = value ? value.toString() : "";
      let hash = await stringToHash(str, "riskTypeNames");
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? {
              ...item,
              riskTypeNames: hash,
              // riskTypeId: event.value.value,
            }
          : item
      );
    } else if (event.field === "isOpportunity") {
      changedValue = {
        ...event.dataItem,
        isOpportunityText: event.value.text,
        isOpportunityValue: event.value.value,
        isOpportunity: event.value.value,
      };
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? {
              ...item,
              [event.field]: event.value.text,
              isOpportunity: event.value.value,
            }
          : item
      );
    } else {
      changedValue = { ...event.dataItem, [event.field]: event.value };
      dataValue = data.map((item) =>
        item.riskRegisterId === event.dataItem.riskRegisterId
          ? { ...item, [event.field]: event.value }
          : item
      );

      if (isImpactColumns(editField)) {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            exitEdit();
          });
        }
      }
    }

    setData(dataValue);
    setCurrentChangedValue((preState) => ({ ...preState, ...changedValue }));
  };
  const expandChange = React.useCallback(
    (dataItem) => {
      dataItem.expanded = !dataItem.expanded;
      let expandRow = expandedRowList ? expandedRowList : [];

      //scroll reset
      document
        .getElementById("DataGrid")
        .getElementsByClassName("k-grid-content")[0].scrollLeft = 0;
      //
      if (expandRow.includes(dataItem.riskRegisterId)) {
        let expanedState = expandedRowList;
        let indexValue = expanedState.findIndex(
          (item) => dataItem.riskRegisterId === item
        );
        expanedState.splice(indexValue, 1);
        expandRow = expanedState;
      } else {
        expandRow.push(dataItem.riskRegisterId);
      }
      data.map((riskReg) => {
        if (riskReg.riskRegisterId === dataItem.riskRegisterId) {
          riskReg["expanded"] = dataItem.expanded;
        }
      });
      setExpandRowList(expandRow);
      setData([...data]);
     
      masterRiskList = [...data];
    },
    [data, setData, expandedRowList, setExpandRowList]
  );

  const editFormView = (dataItem) => {
    try {
      setFormEditFlag(true);
      setFormData(dataItem);
      setShowFormView(true);
      if(myRef&&myRef.current){
        myRef.current.loadEditmode(dataItem);
      }
    } catch (err) {
      console.log(err);
    }
  };
const actionButtonsForViewOnly = (event) => {
  let eventData = event;
  return (
    <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
      <ul className="actionIcon">
        <li>
          <a
            title="View"
            className="greenbtn"
            onClick={() => editFormView(eventData.dataItem)}
          >
            <img src={Images.VIEW} width="12" alt="More" />
          </a>
        </li>
      </ul>
    </td>
  );
};
  const actionButtons = (event) => {
    let eventData = event;
    return eventData.dataItem.riskRegisterId === undefined ||
      eventData.dataItem.riskRegisterId === "" ? (
      <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
          {riskAddBtnHideFlag && (
            <li>
              <a
                title="Submit"
                href="#"
                className="greenbtn icon"
                onClick={saveRiskRegistor}
              >
                <img src={Images.CHECKGREEN} width="12" alt="Check" />
              </a>
            </li>
          )}
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              {/* <img src={Images.DOCUMENT} width="12" alt="Cancel" /> */}

              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/riskregisterdocs/${
                  eventData.dataItem.riskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
          <li>
            <a
              title="Cancel"
              className="redbtn icon"
              onClick={() => removeItem(eventData)}
            >
              <img src={Images.TRASH} width="10" alt="Discard" />
            </a>
          </li>
        </ul>
      </td>
    ) : (
      <td className={stickyClassVal} style={{ left: "42px", right: "0px" }}>
        <ul className="actionIcon">
         
          <li>
            <a
              title="View"
              className="greenbtn"
              onClick={() => editFormView(eventData.dataItem)}
            >
              <img src={Images.VIEW} width="12" alt="More" />
            </a>
          </li>
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              {/* <img src={Images.DOCUMENT} width="12" alt="Cancel" /> */}

              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/riskregisterdocs/${
                  eventData.dataItem.riskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
          <li>
            <a
              title="Delete"
              className="redbtn icon"
              onClick={() => deleteRiskPopupOpen(eventData.dataItem)}
            >
              <img src={Images.TRASH} width="12" alt="More" />
            </a>
          </li>
        </ul>
      </td>
    );
  };

  const manageButtons = (event) => {
    let eventData = event;
    return eventData.dataItem.riskRegisterId != undefined &&
      eventData.dataItem.riskRegisterId != "" ? (
      <td className={stickyClassVal} style={{ left: "107px", right: "0px" }}>
        <ul className="actionIcon">
          <li>
            <a
              title="Documents"
              className={
                eventData.dataItem.documentCount == 0
                  ? "greenbtn roundedBtn icon"
                  : "bluebtn roundedBtn icon"
              }
            >
              {/* <img src={Images.DOCUMENT} width="12" alt="Cancel" /> */}

              <NavLink
                title="Document"
                className={
                  eventData.dataItem.documentCount == 0
                    ? "greenbtn icon"
                    : "bluebtn icon"
                }
                to={`/${secureLocalStorage.getItem(
                  "loggedClient"
                )}/${secureLocalStorage.getItem(
                  "tenantKey"
                )}/home/documents/riskregisterdocs/${
                  eventData.dataItem.riskRegisterId
                }`}
              >
                <img
                  src={
                    eventData.dataItem.documentCount == 0
                      ? Images.DOCUMENT
                      : Images.DOCUMENTBLUE
                  }
                  width="12"
                  alt="Document"
                />
              </NavLink>
            </a>
          </li>
        </ul>
      </td>
    ) : (
      <td
        className="k-grid-content-sticky manageBtns"
        style={{ left: "107px", right: "0px" }}
      ></td>
    );
  };

  const removeItem = (event) => {
    const dataValue = [...data];
    removeData(dataValue, event.dataItem);
    setData(dataValue);
    setAddRiskBtnFlag(true);
    setRiskAddOrEdit(false);
  };

  const removeData = (dataValue, item) => {
    let index = dataValue.findIndex(
      (p) => p === item || (item.ProductID && p.ProductID === item.ProductID)
    );
    if (index >= 0) {
      dataValue.splice(index, 1);
    }
  };

  const [openDeleteModelFlag, setOpenDeleteModelFlag] = React.useState(false);
  const [currentRowId, setCurrentRowId] = React.useState(0);
  const [mitigationCount, setMitigationCount] = React.useState(0);
  const deleteRiskPopupOpen = (row) => {
    setOpenDeleteModelFlag(true);
    setCurrentRowId(row.riskRegisterId);
    setMitigationCount(row.mitigationCount);
  };

  const deleteRiskPopupClose = () => {
    setOpenDeleteModelFlag(false);
    setCurrentRowId(0);
    setMitigationCount(0);
  };

  const deleteRisk = async () => {
    try {
      var requestParams = {
        DeletedBy: currentRowId,
      };
      setLoader(true);
      let response = await Api.deleteRisk(requestParams);
      setLoader(false);

      if (response.status === 200) {
        toastr.success(response.message);
        setOpenDeleteModelFlag(false);
        refreshRisk();
        getiskCount();
      } else {
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const _exporter = React.createRef();
  const _exporterAction = React.createRef();
  const exporter = () => {
    // setActionGridflag(false);
    const risksheet = _exporter.current.workbookOptions();
    const actionsheet = _exporterAction.current.workbookOptions();
    risksheet.sheets[1] = actionsheet.sheets[0];
    risksheet.sheets[0].title = "Risk";
    risksheet.sheets[1].title = "Action";

    _exporter.current.save(risksheet);
  };
  const exportExcel =async () => {
    if (_exporter.current) {
      let filteredData = filterBy(data, filter);
      filteredData.map((riskReg) => {
        //riskReg["isClosed"] = riskReg.isClosed ? "Open" : "Closed";
        Object.keys(riskReg).map(function (field) {
          if (RiskColumns.hasOwnProperty(field)) {
            if (riskReg.riskTypeNames) {
              riskReg["riskTypeNames"] =
                riskReg["riskTypeNamesExport"].toString();
            }
            if (riskReg.riskAlertStakeHolders) {
              riskReg["riskAlertStakeHolders"] =
                riskReg["riskAlertStakeHolders"].toString();
            }
          } else {
            //Custom field
            let arr = riskReg.customFields ? riskReg.customFields : [];
            let temp = arr.find((item) => item.fieldName == field);
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                riskReg[field] = temp.selectedCustomFieldNames.toString();
              } else if (temp.inputType === "Single Drop Down") {
                riskReg[field] = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
              } else if (temp.inputType === "Free Text") {
                riskReg[field] = temp.multiText;
              } else if (temp.inputType === "Numeric") {
                riskReg[field] = temp.multiText;// ? parseInt(temp.multiText) : "";
              } else if (temp.inputType === "Date") {
                riskReg[field] = temp.multiText
                  ? new Date(temp.multiText)
                  : undefined;
              }
            } else {
              //Imapct value
              let arrImp = riskReg.impactResponse ? riskReg.impactResponse : [];
              let imp = arrImp.find((item) => item.name == field);
              if (imp) {
                let str = imp.value.split("_");
                riskReg[field] = str[0] + "(" + str[1] + ")";
              }
            }
          }
        });
      });
      await exporter();
      filteredData.map((riskReg) => {
        if (expandedRowList.includes(riskReg.riskRegisterId)) {
          riskReg["expanded"] = true;
        } else {
          riskReg["expanded"] = false;
        }

        if (riskReg.riskTypeNames) {
          let hashArr = stringToHash(
            riskReg.riskTypeNamesExport.toString(),
            "riskTypeNames"
          );

          riskReg["riskTypeNames"] = hashArr;
        }else{
          riskReg["riskTypeNames"] = "undefined";
          riskReg["riskTypeNamesExport"]="";
        }
        if (riskReg.riskAlertStakeHolders) {
          riskReg["riskAlertStakeHolders"] =
            riskReg["riskAlertStakeHolders"].split(",");
        }

        //customFields
        let riskObj = masterRiskList.find(
          (item) => item.riskRegisterId === riskReg.riskRegisterId
        );
        if (riskObj) {
          riskReg["customFields"] = riskObj.customFields;
          riskReg["impactResponse"]=riskObj.impactResponse;
        }
      });
      let impactMasterTemp = [];
      if (filteredData && filteredData.length > 0) {
        impactMasterTemp = filteredData[0].impactResponse;
      }
      createDynamicCols(filteredData, impactMasterTemp, filter.filters);
      createDynamicDropdowns(filteredData,filter.filters);
      
    }
  };

  const updateRiskRegisterDropDown = async (updateDate) => {
    await updateRiskRegistor(updateDate, true);
    exitEdit();
  };
  const getsortedrisklist=()=>{
    var sorted_arr =  riskTypeList.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sorted_arr
  }

  const getMergedRangeForRowAndHeader = (merges, rowNumber, headerKey, headers) => {
      try{
        const headerIndex = headers.indexOf(headerKey); // Get the column index for the given header
    
        if (headerIndex === -1) {
          console.error(`Header "${headerKey}" not found.`);
          return 0; // Return null if the header is not found
        }
    
          // Check if any merged range includes the specified row and header's column
        for (let merge of merges) {
          const { s: start, e: end } = merge;
  
          // If the merge includes the specified row and the header's column
          if (start.r <= rowNumber - 1 && end.r >= rowNumber - 1 && start.c <= headerIndex && end.c >= headerIndex) {
            // return `${start.r + 1}-${end.r + 1}`;
            return Math.floor(((end.r + 1)-(start.r + 1))/2);
          }
        }
    
      return 0; // If no merged range found
      }catch(err){
        console.error(err)
      }
    
  };
  const handleUpload = (event) => {
    try{
      setImportRequest({});
      var file = event.target.files[0];
      var name = file ? file.name : "invalid file";
      setImportFileName(name);
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {
          type: "array",
          cellText: true,
          cellDates: true,
        });
        const worksheet = workbook.Sheets[excelTemplateValue.templateSheetName];
        if (worksheet) {
         
          const range = XLSX.utils.decode_range(worksheet['!ref']);
          range.s.r = excelTemplateValue.selectedRowNumber - 1;  // Adjust the start row (0-indexed)
          const newRange = XLSX.utils.encode_range(range);
          const dataFromRow = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
            range: newRange,
            raw: false,
            dateNF: "dd-MMM-yyyy",
            // defval: '',  // Default value for empty cells
          });
    
      
          // Convert the array of arrays to an array of objects
          const headers = dataFromRow[0];
          const rows = dataFromRow.slice(1);
          const jsonObjectRisk=[];
          const jsonObjectAction=[];
      
           rows.map((row,i) => {
            let objRisk = {};
            let objAction={};
            headers.forEach((header, index) => {
              header=header?header.replace(/[\n\r]/g, '').trim():null;
              objAction[header] = row[index]?cleanNumber(row[index]):null;
              if (header in objRisk) {
                //exists in myObject
              } else {
                objRisk[header] = row[index]?cleanNumber(row[index]):null;
              }
              
            });
         
            if (worksheet["!merges"] && worksheet["!merges"].length > 0) {
              // Get the merged range information for the given row and header key
              const rowNumber=(i+1) + excelTemplateValue.selectedRowNumber;
              let mergedRange = 0;
              if (worksheet['!merges']) {
                mergedRange = getMergedRangeForRowAndHeader(worksheet['!merges'], rowNumber, headers[1], headers);
              }
              objRisk["rowNumber"] = (i+1) + (excelTemplateValue.selectedRowNumber+mergedRange);
              objAction["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
            } else {
              objRisk["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
              objAction["rowNumber"] = (i+1) + excelTemplateValue.selectedRowNumber;
            }
              jsonObjectRisk.push(objRisk);
              jsonObjectAction.push(objAction);
            });
          let tempObj={};//"Threat / Opportunity"
          let threatOppMappingKey=excelTemplateValue.templateColumns.find((item)=>item.riskwellColumnName==="Threat / Opportunity")?.excelColumnName;
          let riskTitleMappingKey=excelTemplateValue.templateColumns.find((item)=>item.riskwellColumnName==="Risk Title")?.excelColumnName;
  
          let riskArr=jsonObjectRisk.filter((item)=>(item[threatOppMappingKey]!=undefined&&(item[threatOppMappingKey]==="Threat"||item[threatOppMappingKey]==="Opportunity"))||item[riskTitleMappingKey]!=undefined);
  
          console.log("riskArr",riskArr);
          tempObj["RISK"]=riskArr;
  
          let crossRefMappingKey=excelTemplateValue.templateColumns.find((item)=>item.riskwellColumnName==="Risk Title")?.excelColumnName;
          let actionArr=jsonObjectAction.filter((item)=>item[crossRefMappingKey]!=undefined);
          console.log("actionArr",actionArr);
          tempObj["ACTION"]=actionArr;
          setImportRequest(tempObj);
        } else {
          toastr.error('Sheet name not found');
        }
      }
      reader.readAsArrayBuffer(file);
    }catch(err){
      console.error(err);
    }
    
  };
  const cleanNumber = (value) => {
    if (typeof value === "string" && value.includes("%")) {
      let cleanedValue = value.replace("%", "").trim();
      let numberValue = parseFloat(cleanedValue);
      return isNaN(numberValue) ? value : numberValue;
    } else if (typeof value === "number") {
      return value;
    }
    return value;
  };
  const renderSubtrees = (trees) => {
    return trees?.map((tree,index) => {
      return (
        <TreeItem key={index} id={index} toggled={tree.toggled} title={tree.name}>
          {renderSubtrees(tree.subtrees)}
        </TreeItem>
      );
    });
  };
 
  const downloadErrorLogFile=()=>{
    let arr = errorDataList.map((item) => {
      item["toggled"] = true;
      return item;
    });
    setErrorDataList(arr);
    setTimeout(() => {
      if (pdfExportComponent.current) {
        pdfExportComponent.current.save();
      }
      let arr1 = errorDataList.map((item) => {
        item["toggled"] = false;
        return item;
      });
      setErrorDataList(arr1);
    }, 1000);
  }

  const saveRiskDataUploadFile = async () => {
    try {
      setLoader(true);
      var requestParams = {
        TemplateId: excelTemplateValue.templateId,
        RiskListByExcel:importRequest.RISK,
        workstreamId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.saveRisksByExcelUpload(requestParams);
      if (response.excelTemplateSaveRiskResponse) {
        setLoader(false);
        let errorList =
          response.excelTemplateSaveRiskResponse?.excelExceptionList.filter(
            (item) => item.isRowPassed === false
          );
        if (errorList.length === 0) {
          SetValidateBtnFlag(true);
        } else {
          setenable_errorlog(true);
          SetValidateBtnFlag(false);
          let errArr = [];
          errorList.map((row) => {
            let obj = {};
            let childrenArr = [];
            obj["toggled"] = false;
            obj["name"] = "Row " + row.rowNumber + " Failed - "+row.rowTitle;
            let errorCols = row.excelExceptionColumnList.filter(
              (cols) => cols.isPassed === false
            );
            errorCols.map((errorcol) => {
              childrenArr.push({
                name: errorcol.excelColumnName+": "+errorcol.exceptionMessage,
                toggled:false
              });
            });
            obj["subtrees"] = childrenArr;
            errArr.push(obj);

          });
          setErrorDataList(errArr);
        }
        setDataUploadCount({
          totalRow:requestParams?.RiskListByExcel?.length,
          failedRow:errorList?.length,
          successRow:(requestParams?.RiskListByExcel?.length-errorList?.length)
        });
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const saveActionDataUploadFile = async () => {
    try {
      setLoader(true);
      var requestParams = {
        TemplateId: excelTemplateValue.templateId,
        ActionListByExcel: importRequest.ACTION,
        workstreamId: parseInt(props.match.params.organizationUnitId),
      };
      let response = await Api.saveActionsByExcelUpload(requestParams);
      if (response.excelTemplateSaveActionResponse) {
        setLoader(false);
        let errorList =
          response.excelTemplateSaveActionResponse?.excelExceptionList.filter(
            (item) => item.isRowPassed === false
          );
        if (errorList.length === 0) {
          SetValidateBtnFlag(true);
        } else {
          setenable_errorlog(true);
          SetValidateBtnFlag(false);

          let errArr = [];
          errorList.map((row) => {
            let obj = {};
            let childrenArr = [];
            obj["toggled"] = false;
            obj["name"] = "Row " + row.rowNumber + " Failed - "+row.rowTitle;
            let errorCols = row.excelExceptionColumnList.filter(
              (cols) => cols.isPassed === false
            );
            errorCols.map((errorcol) => {
              childrenArr.push({
                name: errorcol.excelColumnName+": "+errorcol.exceptionMessage,
                toggled:false
              });
            });
            obj["subtrees"] = childrenArr;
            errArr.push(obj);
          });
          console.log("errArr", errArr);
          setErrorDataList(errArr);
        }
        setDataUploadCount({
          totalRow:requestParams?.ActionListByExcel?.length,
          failedRow:errorList?.length,
          successRow:(requestParams?.ActionListByExcel?.length-errorList?.length)
        });
      } else {
        setLoader(false);
        toastr.error(response.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };
  const enable_validatepopup=()=>{
    setIsvalidatepopup(true)
  }

  const cancelvalidate=()=>{
    setIsvalidatepopup(false);
  }
  const commitRisk=async(flag)=>{
    try{
      setLoader(true);
      let request={
        WorkstreamId:parseInt(props.match.params.organizationUnitId),
        action:flag
      }
      let response =isRiskImport? await Api.commitRisksByExcelUpload(request):await Api.commitActionsByExcelUpload(request);
      if (response.status === 200) {
        if(flag==="commit"){
          toastr.success(response.message);
        }
        setIsvalidatepopup(false);
        setIsRiskImport(false);
        closepopup();
        setExpandRowList([]);
        refreshRisk();
        setLoader(false);
      }else{
        setExpandRowList([]);
        cancelvalidate();
        setLoader(false);
      }
    }catch(err){
      setLoader(false);
      console.error(err);
    }
  }
  const closepopup=()=>{
    setOpenExcelImport(!excelImport);
    setenable_errorlog(false);
    setErrorDataList([]);
    setImportRequest(undefined);
    setExcelTemplatesValue(undefined);
    setRiskValidationDataCount({
      newRiskCount:0,
      modifiedRiskCount:0,
      closedRiskCount:0
    });
    setPendingCommitFlag(false);
  }

  const expandCell = (props) => (
    <GridExpandComponent {...props} expandChange={expandChange} />
  );

  const handleCellAddValue = (element) => {
    cellAddValue = element;
    // setCurrentChangedValue({...currentChangedValue,[editField]:element});
  };

  const pageChange = (event) => {
    setSkip(event.page.skip);
    setTake(event.page.take);
  };

  const stringToHash = (stringArr, cols) => {
    let hashArr = [];

    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      if (cols == "riskTypeNames") {
        valArr &&
          valArr.map((item1) => {
            let risktype = riskTypemaster.find((item) => item.name == item1);
            if (risktype) {
              hashArr.push(risktype.hashValue);
            }
          });
      }
    } else {
      if (stringArr != "") {
        if (cols == "riskTypeNames") {
          let risktype = riskTypemaster.find((item) => item.name == stringArr);
          if (risktype) {
            hashArr.push(risktype.hashValue);
          }
        }
      }
    }

    return hashArr.toString();
  };
  const convertStrToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return hash;
  };
  const stringToHashForCF = (stringArr, data) => {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    // console.log(hashArr.toString(),stringArr)
    return hashArr.toString();
  };
  const filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      let filterData = existingFilter ? existingFilter : [];
      let filter = e.filter ? e.filter.filters : [];

      // Get the field being filtered from the new filter
      const newFilterFields = new Set();
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }

      // Remove any existing filters for the same fields
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });

      // Combine filtered existing filters with new filters
      let combinedFilters = [...filteredExisting, ...filter];

      // Deduplicate the combined filters
      const uniqueFilters = new Set();
      const dedupedFilters = [];

      for (const filterItem of combinedFilters) {
        const filterStr = JSON.stringify(filterItem);
        if (!uniqueFilters.has(filterStr)) {
          uniqueFilters.add(filterStr);
          dedupedFilters.push(filterItem);
        }
      }
      existingFilterV1 = [...dedupedFilters];
      existingFilter = dedupedFilters;
      const result = filterBy(masterRiskList, dedupedFilters);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      await createDynamicCols(result, impactMasterTemp, dedupedFilters);
      await createDynamicDropdowns(result, dedupedFilters);
      }
      await checkRisktypeSelections(dedupedFilters);
      
      setAction(constructMitigationReps(result));
      setData(result);
     
      setDataState({
        sort: sort,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        group: [],
      });
      // setFilter(e.filter);
      setFilter({
        logic: "and",
        filters: dedupedFilters,
      });
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (existingFilter) {
        let filterData = existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Only add the filter if none of its inner filters match the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === selectedColumn
            );
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            if (filter2.field != selectedColumn) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          }
        });
      }

      existingFilter = exi;
      existingFilterV1 = [...exi];
      const result = filterBy(masterRiskList, exi);
      let impactMasterTemp = [];
      if (result && result.length > 0) {
        impactMasterTemp = result[0].impactResponse;
      }
      await createDynamicCols(result, impactMasterTemp, exi);
      await createDynamicDropdowns(result, exi);
      await checkRisktypeSelections(exi);
      setAction(constructMitigationReps(result));
      setData(result);
    
      setDataState({
        sort: sort,
        take: Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        group: [],
      });
      // setFilter(e.filter);
      setFilter({
        logic: "and",
        filters: exi,
      });
    }
  };

  const filterChangeV = async (e, colname) => {
    // let exi = existingFilter ? existingFilter : existingFilterV1;
    let exi = [];

    let filterData = existingFilter ? existingFilter : existingFilterV1;
    filterData.map((filter2) => {
      if (filter2.filters) {
        filter2.filters.map((innerFilter) => {
          if (innerFilter.field != colname) {
            if (!exi.includes(filter2)) {
              exi.push(filter2);
            }
          }
        });
      } else {
        if (filter2.field != colname) {
          if (!exi.includes(filter2)) {
            exi.push(filter2);
          }
        }
      }
    });

    let filter = e ? e.filters : [];
    let temp = [];
    if (filter.length > 0) {
      temp = [
        {
          filters: filter,
          logic: "or",
        },
      ];
    }
    let arr = [...exi, ...temp];

    existingFilter = arr;
    const result = filterBy(masterRiskList, arr);
    let impactMasterTemp = [];
    if (result && result.length > 0) {
      impactMasterTemp = result[0].impactResponse;
    await createDynamicCols(result, impactMasterTemp, arr);
    await createDynamicDropdowns(result, arr);
    }
    await checkRisktypeSelections(arr);
    setAction(constructMitigationReps(result));
    setData(result);
   
    setFilter({
      logic: "and",
      filters: arr,
    });
    setDataState({
      sort: sort,
      take: Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      group: [],
    });
  };
  const clearFilter = async (e) => {
    let filter = e ? e : [];
    const result = filterBy(masterRiskList, filter);
    let impactMasterTemp = [];
    if (result && result.length > 0) {
      impactMasterTemp = result[0].impactResponse;
    }
    await createDynamicCols(result, impactMasterTemp, filter);
    await createDynamicDropdowns(result, filter);
    await checkRisktypeSelections(filter);
    existingFilter = filter;
    setData(result);
    setFilter({
      logic: "and",
      filters: filter,
    });
   
    setAction(constructMitigationReps(result));
  };

  const onColumnReorder = async (event) => {
    try {
      if(event){
        // const newArray=mergeAndUpdateArrays(persistenceRiskGridTemp,event.target.columnResize.columns);

        let req = {
          RiskDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: parseInt(props.match.params.organizationUnitId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        await Api.persistRisks(req);
      }else{
        //Reset

        let req = {
          RiskDetails: null,
          WorkstreamId: parseInt(props.match.params.organizationUnitId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        await Api.persistRisks(req);
      }

    } catch (err) {
      console.log(err);
    }
  };

  const mergeAndUpdateArrays = (array1, array2) => {
    // Create a Set of indexes present in array2
    const array2Values = new Set(array2.map((item) => item.field));

    // Loop through array1 and push missing items into array2
    array1.forEach((item) => {
      if (!array2Values.has(item.field)) {
        array2.push(item);
      }
    });

    // Sort array2 by index
    array2.sort((a, b) => a.orderIndex - b.orderIndex);
    return array2;
  };

  const onColumnResize = async (event) => {
    if (event.end) {
      // setPersistenceRiskGrid(event.target.columnResize.columns);
      // const newArray=mergeAndUpdateArrays (persistenceRiskGridTemp,event.target.columnResize.columns);
      try {
        let req = {
          RiskDetails: JSON.stringify(event.target.columnResize.columns),
          WorkstreamId: parseInt(props.match.params.organizationUnitId),
          UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
          CreatedDate: new Date(),
          updatedDate: new Date(),
        };
        await Api.persistRisks(req);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getPersistanceAction = async () => {
    try {
      let req = {
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getPersistanceAction(req);
      if (
        response.status == 200 &&
        response.riskActionPersist &&
        response.riskActionPersist.actionDetails
      ) {
        let persis = JSON.parse(response.riskActionPersist.actionDetails);
        setPersistenceActionGrid(persis);   
      } else {
        setPersistenceActionGrid(ActionPersistence);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const refreshPersistence = (event) => {
    try {
      setPersistenceActionGrid(event);
    } catch (err) {
      console.log(err);
    }
  };

  const getPersistance = async () => {
    try {
      let req = {
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getPersistance(req);
      if (
        response.status == 200 &&
        response.riskRegisterPersist &&
        response.riskRegisterPersist.riskDetails
      ) {
        let persis = JSON.parse(response.riskRegisterPersist.riskDetails);
        setPersistenceRiskGrid(persis);
        persistenceRiskGridConst = persis;
        console.log("persis-Risk",persis);
      } else {
        setPersistenceRiskGrid(PersistenceRisk);
      }
    } catch (err) {
      console.log(err);
      setPersistenceRiskGrid(PersistenceRisk);
    }
  };
  const [resetPopup, setResetPopup] = React.useState(false);
  const [riskOrAction, setRiskOrAction] = React.useState("");

  const resetPopupOpen = (flag) => {
    setResetPopup(true);
    setRiskOrAction(flag);
  };
  const resetPopupClose = () => {
    setResetPopup(false);
    setRiskOrAction(null);
  };
  const resetPersistence = async () => {
    try {
      setLoader(true);
      let req = {
        RiskDetails: undefined,
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      let hidereq = {
        ColumnDetails: "[]",
        ColumnType: "Risk",
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };
       Api.saveColumnSettings(hidereq);
      let response = await Api.persistRisks(req);
      if (response.status == 200) {
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const resetActionPersistence = async () => {
    try {
      setLoader(true);
      let req = {
        ActionDetails: undefined,
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
        updatedDate: new Date(),
      };
      let hidereq = {
        ColumnDetails: "[]",
        ColumnType: "Action",
        UserId: parseInt(secureLocalStorage.getItem("loginUserId")),
        WorkstreamId: parseInt(props.match.params.organizationUnitId),
      };
       Api.saveColumnSettings(hidereq);
      let response = await Api.persistAction(req);   
      if (response.status == 200) {
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      } else {
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
    }
  };

  const getGridColum = (columns) => {
    let cellFieldName = columns.field;
    let width = columns.width;
    let isPrime=orgUnit.isPrime&&secureLocalStorage.getItem("isPrime")==true?true:false;
    let isHidden=isHiddenRiskColumn(cellFieldName);
    const fieldNamesSet = new Set(selectedRisksColumnFields.map(item => item.fieldName));

    if (!cellFieldName) {
      return;
    } 
    else if (cellFieldName == "riskTitle"&& !isHidden) {
      return (
        <GridColumn
          field="riskTitle"
          title="Risk Title *"
          width={width}
          resizable={true}
          reorderable={false}
          editable={true}
          locked={fixedGrid}
          fixedScroll={true}
          key={cellFieldName}
          columnIndex
          cell={(props) => (
            <RiskTitleCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("riskTitle")}
        />
      );
    }
    else if (cellFieldName == "createdByName"&& !isHidden) {
      return (
        <GridColumn
          field="createdByName"
          title="Created By"
          width={width}
          resizable={true}
          reorderable={false}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdByName")}
         />
   ) }

     else if (cellFieldName == "isOpportunity"&& !isHidden) {
      return (
        <GridColumn
          // locked={fixedGrid}
          field="isOpportunity"
          title="T/O *"
          width={width}
          minResizableWidth="100"
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          editable={true}
          cell={(props) => (
            <ThreatAndOpportunities
              {...props}
              dropDownData={opportunitiesList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isOpportunity")}
        />
      );
    } else if (cellFieldName == "name" && !isHidden) {
      return (
        <GridColumn
          // locked={true}
          field="name"
          title="Risk Description"
          width={width}
          resizable={true}
          reorderable={true}
          editable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskDescriptionCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("name")}
        />
      );
    } else if (cellFieldName == "riskTypeNames"&& !isHidden) {
      getsortedrisklist();    
      return (
        <GridColumn
          field="riskTypeNames"
          title="Risk Type"
          width={width}
          editable={true}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <DropDownCell
              {...props}
              dropDownData={riskTypeList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <SearchMenu
              {...props}
              existingFilter={existingFilter}
              data={riskTypeList}
              filterChangeV={filterChangeV}
              clearFilter={clearFilter}
            />
          )}
          headerClassName={setClassName("riskTypeNames")}
        />
      );
    } else if (cellFieldName == "customFields") {
      //CF cell
      // return dropdownColumns;
      return dropdownColumns.filter(item => !fieldNamesSet.has(item.props.field));
    } else if (cellFieldName == "mitigationCount"&& !isHidden) {
      return (
        <GridColumn
          field="mitigationCount"
          title="Action Count"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("mitigationCount")}
        />
      );
    } else if (cellFieldName == "cause"&& !isHidden) {
      return (
        <GridColumn
          field="cause"
          title="Cause"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskCauseCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("cause")}
        />
      );
    } else if (cellFieldName == "impactComments"&& !isHidden) {
      return (
        <GridColumn
          field="impactComments"
          title="Consequences"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("impactComments")}
        />
      );
    } else if (cellFieldName == "existingControl"&& !isHidden) {
      return (
        <GridColumn
          field="existingControl"
          title="Existing Control"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <ExistingControlCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("existingControl")}
        />
      );
    } 
    else if (cellFieldName == "progress"&& !isHidden) {
      return (
        <GridColumn
          field="progress"
          title="Progress Status"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskProgressPopup
              {...props}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("progress")}
        />
      );
    } 
    else if (cellFieldName == "frequency"&& !isHidden) {
      return (
        <GridColumn
          field="frequency"
          title="Pre-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          key={cellFieldName}
          cell={(props) => (
            <RiskFrequencyComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("frequency")}
        />
      );
    } else if (cellFieldName == "reductionProbability"&& !isHidden) {
      return (
        <GridColumn
          field="reductionProbability"
          title="Post-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.reductionProbability
                  ? props.dataItem.reductionProbability
                  : 0}
              </span>
            </td>
          )}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("reductionProbability")}
        />
      );
    } else if (cellFieldName == "currentProbability"&& !isHidden) {
      return (
        <GridColumn
          field="currentProbability"
          title="Current-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          key={cellFieldName}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentProbability
                  ? props.dataItem.currentProbability
                  : "0"}
              </span>
            </td>
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("currentProbability")}
        />
      );
    } else if (cellFieldName == "pre"&& !isHidden) {
      return (
        <GridColumn
          field="pre"
          title="pre"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          key={cellFieldName}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    } else if (cellFieldName == "current"&& !isHidden) {
      return (
        <GridColumn
          field="current"
          title="current"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          key={cellFieldName}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    }else if (cellFieldName == "post"&& !isHidden) {
      return (
        <GridColumn
          field="post"
          title="post"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          key={cellFieldName}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    } 
   
    else if (cellFieldName == "preWeightedRiskScore"&&isPrime===true&& !isHidden) {
      return (
        <GridColumn
          field="preWeightedRiskScore"
          title="Prime Risk Score (Pre)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          filter={"numeric"}
          headerClassName={setClassName("preWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
        />
      );
    } else if (cellFieldName == "currentWeightedRiskScore"&&isPrime===true&& !isHidden) {
      return (
        <GridColumn
          field="currentWeightedRiskScore"
          title="Prime Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          key={cellFieldName}
          headerClassName={setClassName("currentWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
          cell={(props) => (
           <td>
             <span className="turquoiseBlue">
               {props.dataItem.currentWeightedRiskScore}
             </span>
           </td>
         )}
        />
      );
    } else if (cellFieldName == "postWeightedRiskScore"&&isPrime===true&& !isHidden) {
      return (
        <GridColumn
          field="postWeightedRiskScore"
          title="Prime Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          key={cellFieldName}
          headerClassName={setClassName("postWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
          cell={(props) => (
           <td>
             <span className="yellowCell">
               {props.dataItem.postWeightedRiskScore}
             </span>
           </td>
         )}
        />
      );
    } else if (cellFieldName == "preRiskScore"&& !isHidden) {
      return (
        <GridColumn
          field="preRiskScore"
          title="Risk Score (Pre)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          key={cellFieldName}
          headerClassName={setClassName("preRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
        />
      );
    } else if (cellFieldName == "currentRiskScore"&& !isHidden) {
      return (
        <GridColumn
          field="currentRiskScore"
          title="Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          key={cellFieldName}
          headerClassName={setClassName("currentRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
          cell={(props) => (
           <td>
             <span className="turquoiseBlue">
               {props.dataItem.currentRiskScore}
             </span>
           </td>
         )}
        />
      );
    } else if (cellFieldName == "postRiskScore"&& !isHidden) {
      return (
        <GridColumn
          field="postRiskScore"
          title="Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          key={cellFieldName}
          headerClassName={setClassName("postRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
          )}
          cell={(props) => (
           <td>
             <span className="yellowCell">
               {props.dataItem.postRiskScore}
             </span>
           </td>
         )}
        />
      );
    }  else if (cellFieldName == "impactFields") {
      // impact cells
      return impactColumns;
    } else if (cellFieldName == "proximityDate"&& !isHidden) {
      return (
        <GridColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"date"}
          key={cellFieldName}
          cell={(props) => (
            <RiskProximityDateCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("proximityDate")}
        />
      );
    } else if (cellFieldName == "alertDescription"&& !isHidden) {
      return (
        <GridColumn
          field="alertDescription"
          title="Alert Description"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertDescription")}
        />
      );
    } else if (cellFieldName == "riskAlertStakeHolders"&& !isHidden) {
      return (
        <GridColumn
          field="riskAlertStakeHolders"
          title="Alert StakeHolders"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <RiskAlertStackHolderComponent
              {...props}
              dropDownData={stackeHolderList}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("riskAlertStakeHolders")}
        />
      );
    } else if (cellFieldName == "owner"&& !isHidden) {
      return (
        <GridColumn
          field="owner"
          width={width}
          title="Owner"
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <OwnerDropDownCell
              {...props}
              dropDownData={ownerListForRisk}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("owner")}
        />
      );
    } else if (cellFieldName == "isClosed"&& !isHidden) {
      return (
        <GridColumn
          field="isClosed"
          title="Status"
          width={width}
          resizable={true}
          reorderable={true}
          key={cellFieldName}
          cell={(props) => (
            <StatusComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
        
          headerClassName={setClassName("isClosed")}
        />
      );
    }
    else if (cellFieldName == "createdDate"&& !isHidden) {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}         
         format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdDate")}
        />
      );
    } else if (cellFieldName == "updatedBy"&& !isHidden) {
      return (
        <GridColumn
          field="updatedBy"
          title="updated By"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedBy")}
        />
      );
    } else if (cellFieldName == "updatedDate"&& !isHidden) {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedDate")}
        />
      );
    }else if (cellFieldName == "closedDate"&& !isHidden) {
      return (
        <GridColumn
          field="closedDate"
          title="Closed Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          key={cellFieldName}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("closedDate")}
        />
      );
    } else {
      let filtereddropdownColumns = dropdownColumns.filter(item => !fieldNamesSet.has(item.props.field));
      let cf = filtereddropdownColumns.find((item) => cellFieldName === item.props.field);
      if (cf) {
        // Clone the object and update width
        let newCf = {
          ...cf,
          props: {
            ...cf.props,
            width: width,
          },
        };

        return newCf;
      } else {
        let imp = impactColumns.find(
          (impact) => cellFieldName === impact.props.field
        );
        if (imp) {
          // Clone the object and update width
        let newCf = {
          ...imp,
          props: {
            ...imp.props,
            width: width,
          },
        };

        return newCf;
        }
      }
    }
  };

  const excel_getGridColum = (columns) => {
    let cellFieldName = columns.field;
    let width = columns.width;
    let isPrime =
      orgUnit.isPrime && secureLocalStorage.getItem("isPrime") == true
        ? true
        : false; 

    if (!cellFieldName) {
      return;
    } else if (cellFieldName == "number") {
      return (
        <GridColumn
          locked={fixedGrid}
          field="number"
          title="Risk Number"
          width="100px"
          editable={false}
          minResizableWidth="100"
          resizable={false}
          reorderable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("number")}
        />
      );
    } else if (cellFieldName == "riskTitle") {
      return (
        <GridColumn
          field="riskTitle"
          title="Risk Title *"
          width={width}
          resizable={true}
          reorderable={false}
          editable={true}
          locked={fixedGrid}
          fixedScroll={true}
          cell={(props) => (
            <RiskTitleCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("riskTitle")}
        />
      );
    } else if (cellFieldName == "isOpportunity") {
      return (
        <GridColumn
          // locked={fixedGrid}
          field="isOpportunity"
          title="T/O *"
          width={width}
          minResizableWidth="100"
          resizable={true}
          reorderable={true}
          // locked={fixedGrid}
          editable={true}
          cell={(props) => (
            <ThreatAndOpportunities
              {...props}
              dropDownData={opportunitiesList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("isOpportunity")}
        />
      );
    } else if (cellFieldName == "name") {
      return (
        <GridColumn
          // locked={true}
          field="name"
          title="Risk Description"
          width={width}
          resizable={true}
          reorderable={true}
          editable={true}
          // locked={fixedGrid}
          cell={(props) => (
            <RiskDescriptionCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("name")}
        />
      );
    } else if (cellFieldName == "riskTypeNames") {
      getsortedrisklist();    
      return (
        <GridColumn
          field="riskTypeNames"
          title="Risk Type"
          width={width}
          editable={true}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <DropDownCell
              {...props}
              dropDownData={riskTypeList}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <SearchMenu
              {...props}
              existingFilter={existingFilter}
              data={riskTypeList}
              filterChangeV={filterChangeV}
              clearFilter={clearFilter}
            />
          )}
          headerClassName={setClassName("riskTypeNames")}
        />
      );
    } else if (cellFieldName == "customFields") {
      //CF cell
      return dropdownColumns;
    } else if (cellFieldName == "mitigationCount") {
      return (
        <GridColumn
          field="mitigationCount"
          title="Action Count"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("mitigationCount")}
        />
      );
    } else if (cellFieldName == "cause") {
      return (
        <GridColumn
          field="cause"
          title="Cause"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCauseCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("cause")}
        />
      );
    } else if (cellFieldName == "impactComments") {
      return (
        <GridColumn
          field="impactComments"
          title="Consequences"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("impactComments")}
        />
      );
    } else if (cellFieldName == "existingControl") {
      return (
        <GridColumn
          field="existingControl"
          title="Existing Control"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <ExistingControlCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("existingControl")}
        />
      );
    }
    // else if (cellFieldName == "progress") {
    //   return (
    //     <GridColumn
    //       field="progress"
    //       title="Progress Status"
    //       width={width}
    //       resizable={true}
    //       reorderable={true}
    //       cell={(props) => (
    //         <RiskProgressPopup
    //           {...props}
    //           onEditCell={enterEdit}
    //           exitEdit={exitEdit}
    //           updateDropdownValue={updateRiskRegisterDropDown}
    //         />
    //       )}
    //       columnMenu={(props) => (
    //         <ColumnMenuFilter
    //           {...props}
    //           getSelectedColumn={getSelectedColumn}
    //         />
    //       )}
    //       headerClassName={setClassName("progress")}
    //     />
    //   );
    // }
    else if (cellFieldName == "frequency") {
      return (
        <GridColumn
          field="frequency"
          title="Pre-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          cell={(props) => (
            <RiskFrequencyComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("frequency")}
        />
      );
    } else if (cellFieldName == "reductionProbability") {
      return (
        <GridColumn
          field="reductionProbability"
          title="Post-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.reductionProbability
                  ? props.dataItem.reductionProbability
                  : 0}
              </span>
            </td>
          )}
          filter={"numeric"}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("reductionProbability")}
        />
      );
    } else if (cellFieldName == "currentProbability") {
      return (
        <GridColumn
          field="currentProbability"
          title="Current-Probability (%)"
          width={width}
          resizable={true}
          reorderable={true}
          filter={"numeric"}
          editable={false}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentProbability
                  ? props.dataItem.currentProbability
                  : "0"}
              </span>
            </td>
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("currentProbability")}
        />
      );
    } else if (cellFieldName == "pre") {
      return (
        <GridColumn
          field="pre"
          title="pre"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    }else if (cellFieldName == "current") {
      return (
        <GridColumn
          field="current"
          title="current"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    }  else if (cellFieldName == "post") {
      return (
        <GridColumn
          field="post"
          title="post"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          sortable={false}
          cell={(props) => (
            <PrePostComponenant
              {...props}
              HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
            />
          )}
        />
      );
    }
    // else if (cellFieldName == "overAll") {
    //   return (
    //     <GridColumn
    //       field="overAll"
    //       title="OverAll Impact"
    //       width={width}
    //       resizable={true}
    //       reorderable={true}
    //       editable={false}
    //       sortable={false}
    //       cell={(props) => <OverallComponenant {...props} />}
    //     />
    //   );
    // }
    else if (cellFieldName == "preWeightedRiskScore" && isPrime === true) {
      return (
        <GridColumn
          field="preWeightedRiskScore"
          title="Prime Risk Score (Pre)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("preWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
        />
      );
    } else if (
      cellFieldName == "currentWeightedRiskScore" &&
      isPrime === true
    ) {
      return (
        <GridColumn
          field="currentWeightedRiskScore"
          title="Prime Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("currentWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentWeightedRiskScore}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "postWeightedRiskScore" && isPrime === true) {
      return (
        <GridColumn
          field="postWeightedRiskScore"
          title="Prime Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("postWeightedRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.postWeightedRiskScore}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "preRiskScore") {
      return (
        <GridColumn
          field="preRiskScore"
          title="Risk Score (Pre)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("preRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
        />
      );
    } else if (cellFieldName == "currentRiskScore") {
      return (
        <GridColumn
          field="currentRiskScore"
          title="Risk Score (Current)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("currentRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentRiskScore}
              </span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "postRiskScore") {
      return (
        <GridColumn
          field="postRiskScore"
          title="Risk Score (Post)"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          filter={"numeric"}
          headerClassName={setClassName("postRiskScore")}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          cell={(props) => (
            <td>
              <span className="yellowCell">{props.dataItem.postRiskScore}</span>
            </td>
          )}
        />
      );
    } else if (cellFieldName == "impactFields") {
      // impact cells
      return impactColumns;
    } else if (cellFieldName == "proximityDate") {
      return (
        <GridColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width={width}
          // editor="date"
          resizable={true}
          reorderable={true}
          filter={"date"}
          // format="{0:dd-MMM-yyyy}"

          cell={(props) => (
            <RiskProximityDateCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              handleCellAddValue={handleCellAddValue}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("proximityDate")}
        />
      );
    } else if (cellFieldName == "alertDescription") {
      return (
        <GridColumn
          field="alertDescription"
          title="Alert Description"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskCommonCell
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
              currentChangedValue={currentChangedValue}
              handleCellAddValue={handleCellAddValue}
              riskAddOrEdit={riskAddOrEdit}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("alertDescription")}
        />
      );
    } else if (cellFieldName == "riskAlertStakeHolders") {
      return (
        <GridColumn
          field="riskAlertStakeHolders"
          title="Alert StakeHolders"
          width={width}
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <RiskAlertStackHolderComponent
              {...props}
              dropDownData={stackeHolderList}
              onEditCell={enterEdit}
              exitEdit={exitEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("riskAlertStakeHolders")}
        />
      );
    } else if (cellFieldName == "owner") {
      return (
        <GridColumn
          field="owner"
          width={width}
          title="Owner"
          resizable={true}
          reorderable={true}
          cell={(props) => (
            <OwnerDropDownCell
              {...props}
              dropDownData={ownerListForRisk}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("owner")}
        />
      );
    } else if (cellFieldName == "isClosed") {
      return (
        <GridColumn
          field="isClosed"
          title="Status"
          width={width}
          resizable={true}
          reorderable={true}
          // editor="boolean"
          filter={"boolean"}
          cell={(props) => (
            <StatusComponent
              {...props}
              onEditCell={enterEdit}
              updateDropdownValue={updateRiskRegisterDropDown}
            />
          )}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          // columnMenu={(props) => (
          //   <ColumnMenuFilter
          //     {...props}
          //     getSelectedColumn={getSelectedColumn}
          //   />
          // )}
          headerClassName={setClassName("isClosed")}
        />
      );
    } else if (cellFieldName == "updatedBy") {
      return (
        <GridColumn
          field="updatedBy"
          title="updated By"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedBy")}
        />
      );
    } else if (cellFieldName == "updatedDate") {
      return (
        <GridColumn
          field="updatedDate"
          title="updated Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("updatedDate")}
        />
      );
    }else if (cellFieldName == "createdDate") {
      return (
        <GridColumn
          field="createdDate"
          title="created Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuFilter
              {...props}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdDate")}
        />
      );
    }
    else if (cellFieldName == "createdByName") {
      return (
        <GridColumn
          field="createdByName"
          title="created By"
          width={width}
          resizable={true}
          reorderable={true}
          editable={false}
          columnMenu={(props) => (
            <ColumnMenuCheckboxFilter
              {...props}
              data={data}
              getSelectedColumn={getSelectedColumn}
            />
          )}
          headerClassName={setClassName("createdByName")}
        />
      );
          }
          else if (cellFieldName == "closedDate") {
            return (
              <GridColumn
                field="closedDate"
                title="Closed Date"
                filter={"date"}
                format="{0:dd-MMM-yyyy}"
                width={width}
                resizable={true}
                reorderable={true}
                editable={false}
                columnMenu={(props) => (
                  <ColumnMenuFilter
                    {...props}
                    getSelectedColumn={getSelectedColumn}
                  />
                )}
                headerClassName={setClassName("closedDate")}
              />
            );
          }
    else {
      let cf = dropdownColumns.find(
        (item) => cellFieldName === item.props.field
      );
      if (cf) {
        return cf;
      } else {
        let imp = impactColumns.find(
          (impact) => cellFieldName === impact.props.field
        );
        if (imp) {
          return imp;
        }
      }
    }
  };
  let isPrime=orgUnit.isPrime?true:false;//secureLocalStorage.getItem("isPrime")==true?true:false;

  const actionrow = (r) => {
    let FieldName = r.field;
    if (!FieldName) {
      return;
    } else if (FieldName == "approved") {
      return (
        <ExcelExportColumn
          field="approved"
          title="Approved"
          width="100px"
          resizable={true}
          reorderable
        />
      );
    }
    else if (FieldName == "name") {
      return (
        <ExcelExportColumn
          field="name"
          title="Action Title "
          width="150px"
          reorderable={false}
          editable={true}
        />
      );
    } 
    else if (FieldName == "actionType") {
      return (
        <ExcelExportColumn
          field="actionType"
          title="Action Type"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "number") {
      return (
        <ExcelExportColumn
          field="number"
          title="Action Number"
          width="150px"
          reorderable={false}
          editable={true}
        />
      );
    } else if (FieldName == "control") {
      return (
        <ExcelExportColumn
          field="control"
          title="Description"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "externalReference") {
      return (
        <ExcelExportColumn
          field="externalReference"
          title="External Reference"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "cost") {
      return (
        <ExcelExportColumn
          field="cost"
          title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "reductionFrequency") {
      return (
        <ExcelExportColumn
          field="reductionFrequency"
          title="Reduction in Probability (%)"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "spi") {
      return (
        <ExcelExportColumn
          field="spi"
          title="% On Track"
          width="150px"
          filter={"number"}
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "percentageCompletion") {
      return (
        <ExcelExportColumn
          field="percentageCompletion"
          title="% Completion"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "projectedCompletionDate") {
      return (
        <ExcelExportColumn
          field="projectedCompletionDate"
          width="200px"
          title="Projected Completion Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "actualCompletionDate") {
      return (
        <ExcelExportColumn
          field="actualCompletionDate"
          width="200px"
          title="Actual Completion Date"
          filter={"date"}
          format="{0:dd-MMM-yyyy}"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    }
    if (FieldName == "ImpactFields") {
      // impact cells
      return actionimpactcolumn;
    } else if (FieldName == "delayConsequence") {
      return (
        <ExcelExportColumn
          field="delayConsequence"
          title="Delay Consequence"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } 
    else if (FieldName == "departments") {
      return (
        <ExcelExportColumn
          field="departments"
          title="Departments"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    }
	 else if (FieldName == "externalStatus") {
      return (
        <ExcelExportColumn
          field="externalStatus"
          title="External Status"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    }
	 else if (FieldName == "weeklyReport") {
      return (
        <ExcelExportColumn
          field="weeklyReport"
          title="Weekly Report"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    }
    else if (FieldName == "owner") {
      return (
        <ExcelExportColumn
          field="owner"
          title="Owner"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "proximityDate") {
      return (
        <ExcelExportColumn
          field="proximityDate"
          title="Proximity Alert Date"
          width="200px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "alertDescription") {
      return (
        <ExcelExportColumn
          field="alertDescription"
          title="Alert Description"
          width="300px"
          resizable={true}
          editable={true}
          reorderable={true}
        />
      );
    } else if (FieldName == "actionAlertStakeHolders") {
      return (
        <ExcelExportColumn
          field="actionAlertStakeHolders"
          title="Alert StakeHolders"
          width="250px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "originalCompletionDate") {
      return (
        <ExcelExportColumn
          field="originalCompletionDate"
          title="Original Completion Date"
          width="200px"
          format="{0:dd-MMM-yyyy}"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    } else if (FieldName == "isOpen") {
      return (
        <ExcelExportColumn
          field="isOpen"
          title="Status"
          width="100px"
          resizable={true}
          reorderable={true}
          editable={true}
        />
      );
    }else if (FieldName == "createdDate") {
      return (
        <ExcelExportColumn
        field="createdDate"
        title="Created Date"
        width="150px"
        resizable={true}
        reorderable={true}
        editable={false}
        />
      );
    } 
    else if (FieldName == "createdByName") {
      return (
        <ExcelExportColumn
        field="createdByName"
        title="Created By"
        width="150px"
        resizable={true}
        reorderable={true}
        editable={false}
        />
      );
    }    else if (FieldName == "updatedBy") {
      return (
        <ExcelExportColumn
          field="updatedBy"
          title="updated By"
          width="100px"
          resizable={true}
          reorderable={true}
          editable={false}
        />
      );
    } else if (FieldName == "updatedDate") {
      return (
        <ExcelExportColumn
          field="updatedDate"
          title="updated Date"
          width="150px"
          resizable={true}
          reorderable={true}
          editable={false}
        />
      );
    } 
  
  else {
      let imp = actionimpactcolumn.find(
        (impact) => FieldName === impact.props.field
      );
      if (imp) {
        return imp;
      }
    }
  };
  const exportGrid = (
    <Grid
      style={{ minHeight: "100px" }}
      data={process(data, dataState)}
      reorderable
      resizable
      pageable={true}
      sortable={true}
      onItemChange={itemChange}
      cellRender={
        workstreamRole == "Standard User" || workstreamRole == "View Only"
          ? ""
          : cellRender
      }
      rowRender={rowRender}
      editField="inEdit"
      groupable={false}
      expandField="expanded"
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
    >
      <GridColumn
        // locked={fixedGrid}
        field="number"
        title="Risk Number"
        width="100px"
        editable={false}
        minResizableWidth="100"
        resizable={false}
        reorderable={false}
      />
      <GridColumn
        // locked={true}
        field="riskTitle"
        title="Risk Title *"
        width="150px"
        // locked={true}
        minResizableWidth="250"
        resizable={false}
        reorderable={false}
       
      
      />
      <GridColumn
        // locked={fixedGrid}
        field="isOpportunity"
        title="T/O *"
        width="100px"
        minResizableWidth="100"
        editable={true}
        cell={(props) => (
          <ThreatAndOpportunities
            {...props}
            dropDownData={opportunitiesList}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
          />
        )}
        reorderable={false}
      />
      <GridColumn
        // locked={true}
        field="name"
        title="Risk Description"
        width="250px"
        cell={(props) => (
          <RiskDescriptionCell
            {...props}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
            currentChangedValue={currentChangedValue}
            handleCellAddValue={handleCellAddValue}
            riskAddOrEdit={riskAddOrEdit}
          />
        )}
      />
      <GridColumn
        field="riskTypeNamesExport"
        title="Risk Type"
        width="160px"
        editable={true}
      />

      <GridColumn
        field="mitigationCount"
        title="Action Count"
        width="80px"
        filter={"numeric"}
        editable={false}
      />

      <GridColumn
        field="cause"
        title="Cause"
        width="100px"
        cell={(props) => (
          <RiskCauseCell
            {...props}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
            handleCellAddValue={handleCellAddValue}
            riskAddOrEdit={riskAddOrEdit}
          />
        )}
      />
      <GridColumn
        field="existingControl"
        title="Existing Control"
        width="200px"
        cell={(props) => (
          <ExistingControlCell
            {...props}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
            handleCellAddValue={handleCellAddValue}
            riskAddOrEdit={riskAddOrEdit}
          />
        )}
      />
      <GridColumn
        field="frequency"
        title="Pre-Probability (%)"
        width="80px"
        filter={"numeric"}
        cell={(props) => (
          <RiskFrequencyComponent
            {...props}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
            handleCellAddValue={handleCellAddValue}
            riskAddOrEdit={riskAddOrEdit}
          />
        )}
      />
      <GridColumn
        field="currentProbability"
        title="Current Probability (%)"
        width="80px"
        editable={false}
        cell={(props) => (
          <td>
            <span className="turquoiseBlue">
              {props.dataItem.currentProbability}
            </span>
          </td>
        )}
      />
      <GridColumn
        field="reductionProbability"
        title="Post-Probability (%)"
        width="75px"
        editable={false}
        cell={(props) => (
          <td>
            <span className="yellowCell">
              {props.dataItem.reductionProbability}
            </span>
          </td>
        )}
        filter={"numeric"}
      />

      <GridColumn
        field="pre"
        title="pre"
        width="75px"
        editable={false}
        sortable={false}
        cell={(props) => (
          <PrePostComponenant
            {...props}
            HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
          />
        )}
      />
      <GridColumn
      field="current"
      title="current"
      width="75px"
      editable={false}
      sortable={false}
      cell={(props) => (
        <PrePostComponenant
          {...props}
          HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
            HeatMapConfigDataThreat={HeatMapConfigDataThreat}
            dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
        />
      )}
    />

      <GridColumn
        field="post"
        title="post"
        width="75px"
        editable={false}
        sortable={false}
        cell={(props) => (
          <PrePostComponenant
            {...props}
            HeatMapConfigDataOpportunity={HeatMapConfigDataOpportunity}
              HeatMapConfigDataThreat={HeatMapConfigDataThreat}
              dynamicHeatmapProbabilityRange={dynamicHeatmapProbabilityRange}
          />
        )}
      />
      {/* <GridColumn
        field="overAll"
        title="OverAll Impact"
        width="100px"
        editable={false}
        sortable={false}
        cell={(props) => <OverallComponenant {...props} />}
      /> */}
{/* New  */}

        <GridColumn
          field="preRiskScore"
          title="Risk Score (Pre)"
          filter={"numeric"}
          width="80px"
          editable={false}
        />
      
      {isPrime && (
        <GridColumn
          field="preWeightedRiskScore"
          title="Prime Risk Score (Pre)"
          filter={"numeric"}
          width="80px"
          editable={false}
        />
      )}
      
        <GridColumn
          field="currentRiskScore"
          title="Risk Score (Current)"
          filter={"numeric"}
          width="80px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentRiskScore}
              </span>
            </td>
          )}
        />
     
      {isPrime && (
        <GridColumn
          field="currentWeightedRiskScore"
          title="Prime Risk Score (Current)"
          filter={"numeric"}
          width="80px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="turquoiseBlue">
                {props.dataItem.currentWeightedRiskScore}
              </span>
            </td>
          )}
        />
      )}
      
        <GridColumn
          field="postRiskScore"
          title="Risk Score (Post)"
          filter={"numeric"}
          width="80px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.postRiskScore}
              </span>
            </td>
          )}
        />
      
      {isPrime && (
        <GridColumn
          field="postWeightedRiskScore"
          title="Prime Risk Score (Post)"
          filter={"numeric"}
          width="80px"
          editable={false}
          cell={(props) => (
            <td>
              <span className="yellowCell">
                {props.dataItem.postWeightedRiskScore}
              </span>
            </td>
          )}
        />
      )}
      {/* End  */}
      {impactColumns}
      <GridColumn
        field="owner"
        width="100px"
        title="Owner"
        cell={(props) => (
          <OwnerDropDownCell
            {...props}
            dropDownData={ownerListForRisk}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
          />
        )}
      />
      <GridColumn
        field="isClosed"
        title="Status"
        width="70px"
        // editor="boolean"
        filter={"boolean"}
        cell={(props) => (
          <StatusComponent
            {...props}
            onEditCell={enterEdit}
            updateDropdownValue={updateRiskRegisterDropDown}
          />
        )}
      />
    </Grid>
  );
  const riskGrid = (
    <Grid
      ref={gridRef}
      data={process(data, dataState)}
      reorderable={masterRiskList.length == 0 ? false : true}
      resizable={masterRiskList.length == 0 ? false : true}
      pageable={true}
      onItemChange={itemChange}
      cellRender={cellRender}
      rowRender={rowRender}
      editField="inEdit"
      groupable={false}
      expandField="expanded"
      filterOperators={filterOperators}
      detail={(props) => (
        <MitigationExpandEdit
          {...props}
          getRiskRegistorList={getRiskRegistorList}
          refreshRisk={refreshRisk}
          ownerListForMitigation={ownerListForRisk}
          stackeHolderList={stackeHolderList}
          actionTypeListForRisk={actionTypeListForRisk}
          persistenceActionGrid={persistenceActionGrid}
          refreshPersistence={refreshPersistence}
          orgUnit={orgUnit}
          heatMapCount={heatmapCount}
          selectedActionsColumnFields={selectedActionsColumnFields}
        />
      )}
      {...dataState}
      onDataStateChange={(e) => {
        setDataState(e.dataState);
      }}
      sortable={
        data.length == 0
          ? false
          : {
              allowUnsort: true,
              mode: "multiple",
            }
      }
      onFilterChange={filterChangeExisting}
      onColumnReorder={onColumnReorder}
      onColumnResize={onColumnResize}
      filter={filter}
    >
      <GridColumn
        locked={fixedGrid}
        cell={expandCell}
        width="42px"
        title=""
        minResizableWidth="42"
        resizable={false}
        reorderable={false}
      />

      {workstreamRole == "Standard User" || workstreamRole == "View Only" ? (
        <GridColumn
        locked={fixedGrid}
        cell={actionButtonsForViewOnly}
        width="65px"
        filterable={false}
        minResizableWidth="65"
        resizable={false}
        reorderable={false}
      />
      ) : (
        <GridColumn
          locked={fixedGrid}
          cell={actionButtons}
          width="150px"
          filterable={false}
          // minResizableWidth="100"
          resizable={false}
          reorderable={false}
        />
      )}
      {/* {workstreamRole == "Standard User" || workstreamRole == "View Only" ? (
        <td></td>
      ) : (
        <GridColumn
          locked={fixedGrid}
          title="Attachments"
          cell={manageButtons}
          width="85px"
          filterable={false}
          minResizableWidth="85"
          resizable={false}
          reorderable={false}
        />
      )} */}
      <GridColumn
        locked={fixedGrid}
        field="number"
        title="Risk Number"
        width="100px"
        editable={false}
        minResizableWidth="100"
        resizable={false}
        reorderable={false}
        columnMenu={(props) => (
          <ColumnMenuFilter {...props} getSelectedColumn={getSelectedColumn} />
        )}
        headerClassName={setClassName("number")}
      />

      {persistenceRiskGrid.map((columns) => getGridColum(columns))}

      <ExcelExportColumn
        field="progressHistory"
        title="Progress Status History"
        width="200px"
        cellOptions={{
          wrap: true,
          textAlign: "left",
          verticalAlign: "top",
        }}
      />
    </Grid>
    
  );
  const actionGrid3 = (
    <Grid style={{ display: "none" }}>
       <ExcelExportColumn
        field="organisationName"
        title="Workstream"
        width="200px"
     />
      <ExcelExportColumn
        field="riskTitle"
        title="Risk Title"
        width="200px"
     />
     <ExcelExportColumn
        field="riskNumber"
        title="Risk Number"
        width="200px"
     />
      {persistenceActionGrid.map((r) => actionrow(r))}
        <ExcelExportColumn
        field="progressHistory"
        title="Progress Status History"
        width="200px"
        resizable={true}
        reorderable={true}
        editable={true}
        cellOptions={{
         wrap: true,
         textAlign: "left",
         verticalAlign: "top",
       }}
     />
     
    </Grid>
  );
  const riskgrid1=(
    <Grid style={{ display: "none" }}>
    {persistenceRiskGrid.map((columns) => excel_getGridColum(columns))}
    <ExcelExportColumn
        field="progressHistory"
        title="Progress Status History"
        width="200px"
        cellOptions={{
          wrap: true,
          textAlign: "left",
          verticalAlign: "top",
        }}
      />
  </Grid>
  )

  let gridPDFExport;

  const exportPDF = () => {
    setLoader(true);
    var filteredData = filterBy(data, filter);
    gridPDFExport.save(filteredData);
    pdfTitlePopupClose();
    setLoader(false);
    setTitle("");
  };

  const pdfTitlePopupClose = () => {
    setOpenPdfTitlePopup(false);
  };
  const pdfTitlePopupOpen = () => {
    setOpenPdfTitlePopup(true);
  };

  const getSelectedColumn = (col) => {
    if (col != selectedColumn) {
      selectedColumn = col;
    }
  };

  const [copyRiskAndActionFlag, setCopyRiskAndActionFlag] = useState(false);
  const openCopyRiskAndActionPopup = () => {
    setCopyRiskAndActionFlag(true);
  };
  const closeCopyRiskAndActionPopup = () => {
    setCopyRiskAndActionFlag(false);
  };
  const itemRenderRisk = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const itemRenderAction = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          name={itemProps.dataItem}
          checked={itemProps.selected}
          onChange={(e) => itemProps.onClick(itemProps.index, e)}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
  return (
    <div
      className={
        viewMiti ? "riskDashboardCont openSidebar" : "riskDashboardCont "
      }
    >
      {loader ? (
        <span className="MatTableSpinner">
          <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
        </span>
      ) : null}

      {/* Risk Form View */}
      <RiskRegisterFormView
        formEditFlag={formEditFlag}
        formData={formData}
        showFormView={showFormView}
        orgUnit={orgUnit}
        closeRiskFormView={closeRiskFormView}
        addRiskDataFromForm={addRiskDataFromForm}
        dropDownData={stackeHolderList}
        riskTypeList={riskTypeList}
        ownerListForRisk={ownerListForRisk}
        heatMapCount={heatmapCount}
        selectedRisksColumnFields={selectedRisksColumnFields}
        customFieldsData={
          customFieldsData.length > 0 ? customFieldsData : customFieldsDataState
        }
        {...props}
        ref={myRef}
      />
      {/* copy risk and action  */}

      <CopyRiskAndAction
        copyRiskAndActionFlag={copyRiskAndActionFlag}
        closeCopyRiskAndActionPopup={closeCopyRiskAndActionPopup}
        orgUnitId={props.match.params.organizationUnitId}
        getRiskRegistorList={refreshRisk}
      />

      <div className="riskDashboard sidebarOpened">
        {/* Impact Rating  */}

        {openImpactRating && (
          <Window
            title={"Rating Table"}
            onClose={ImpactRatingClose}
            className="statusWindow ratingTable"
            initialLeft={250}
            initialTop={200}
            initialWidth={680}
            initialHeight={530}
            resizable={false}
            minimizeButton={() => null}
            maximizeButton={() => null}
            restoreButton={() => null}
          >
            <div className=" tblCont dataGrids ">
              <div className="rw-tab-content">
                <label>Probability Range</label>
                <Grid
                  data={probabilityRangeMaster}
                  reorderable
                  resizable
                  // total={impactslist.length}
                >
                  {probability_value}
                </Grid>
              </div>

              <br></br>
              <div className="rw-tab-content">
                <label>Quantitative rating table</label>
                <Grid
                  data={impactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={impactslist.length}
                  pageable={true}
                  onPageChange={pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Impact"
                    width="150"
                    cell={(props) => (
                      <td
                        title={
                          props.dataItem.name ? props.dataItem.name : "Default"
                        }
                      >
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />
                  {/* <GridColumn field="units" title="Unit" width="150" /> */}
                  {probabilityColumns}
                </Grid>
              </div>

              <br></br>
              <div className="rw-tab-content">
                <label>Qualitative rating table</label>
                <Grid
                  data={qualitativeImpactslist.slice(skip, take + skip)}
                  reorderable
                  resizable
                  skip={skip}
                  take={take}
                  total={qualitativeImpactslist.length}
                  pageable={true}
                  onPageChange={pageChange}
                >
                  <GridColumn
                    field="name"
                    title="Name"
                    width="150"
                    cell={(props) => (
                      <td>
                        {props.dataItem.name ? props.dataItem.name : "Default"}
                      </td>
                    )}
                  />
                  {probabilityColumns}
                </Grid>
              </div>
              <br></br>
              {orgUnit.isPrime == true &&
              secureLocalStorage.getItem("isPrime") == true ? (
                <div className="rw-tab-content">
                  <label>Prime Weightings</label>
                  <Grid
                    data={weightageList.slice(skip, take + skip)}
                    reorderable
                    resizable
                    skip={skip}
                    take={take}
                    total={weightageList.length}
                    pageable={true}
                    onPageChange={pageChange}
                  >
                    <GridColumn
                      field="impactVariable"
                      title="Impact variable"
                      width="150"
                    />
                    <GridColumn field="ratio" title="Weighting" width="100" />
                  </Grid>
                </div>
              ) : (
                ""
              )}
            </div>
          </Window>
        )}
        {/* Excel Import Dialog */}
        {isvalidatepopup === false && (
          <Popup show={excelImport} popupClass={"popup-content"}>
            <div className="importriskpoup">
              {loader ? (
                <span className="MatTableSpinner">
                  <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                </span>
              ) : null}
              <div className="importheader">
                <h3>
                  {isRiskImport ? "Risk Import File" : "Action Import File"}
                </h3>
              </div>
              {pendingCommitFlag === true ? (
                <div className="importheader">
                  <h3>Pending Commit already exist.</h3>
                  <div className="btnCont">
                    <div className="action_btn">
                      <button
                        className="validate_btn_pending"
                        onClick={enable_validatepopup}
                      >
                        Validate
                      </button>
                      <div onClick={closepopup} className="Cancel__btn">
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="selecttemplate">
                  <label style={{ color: "#ffffff" }}>Select Template: </label>
                  <DropDownList
                    data={
                      isRiskImport
                        ? excelTemplates.filter(
                            (item) => item.templateType === "risk"
                          )
                        : excelTemplates.filter(
                            (item) => item.templateType === "action"
                          )
                    }
                    onChange={(e) => setExcelTemplatesValue(e.target.value)}
                    style={{ width: "100%" }}
                    textField="templateName"
                    value={excelTemplateValue}
                    id="templateId"
                  />
                  {excelTemplateValue ? (
                    <div
                      className="exportDialogCont"
                      style={{
                        padding: "0px",
                        minHeight: "70px ",
                        width: "100% ",
                        marginTop: "12px",
                      }}
                    >
                      <div className="uploadSec" style={{ height: "80px " }}>
                        <div
                          className="innerBorder"
                          style={{ height: "60px ", maxHeight: "60px " }}
                        >
                          <p>
                            {isRiskImport
                              ? "Upload Your Risk File"
                              : "Upload Your Action File"}
                          </p>
                          <span>
                            {importFileName
                              ? importFileName
                              : "File should be in .xlsx format"}
                          </span>
                          <input
                            type="file"
                            accept=".xlsx"
                            onChange={handleUpload}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="btnCont">
                    <div className="action_btn">
                      {validateBtnFlag && (
                        <button
                          className="validate_btn"
                          onClick={enable_validatepopup}
                        >
                          Validate
                        </button>
                      )}
                      <button
                        onClick={
                          isRiskImport
                            ? saveRiskDataUploadFile
                            : saveActionDataUploadFile
                        }
                        className="Submit__btn"
                        disabled={
                          (importFileName
                            ? false
                            : true ||
                              excelTemplateValue === "undefined" ||
                              excelTemplateValue === "null") ||
                          enable_errorlog === true ||
                          validateBtnFlag
                        }
                      >
                        Submit
                      </button>
                      <div onClick={closepopup} className="Cancel__btn">
                        Cancel
                      </div>
                    </div>

                    {enable_errorlog === true && (
                      <div>
                        <div className="btnCont">
                          <div
                            className="action_btn"
                            style={{ justifyContent: "flex-start" }}
                          >
                            <ul className="Rowcount">
                              <li>
                                <span>
                                  Total Rows:{dataUploadCount.totalRow}
                                </span>
                              </li>
                              <li>
                                <span>Failed:{dataUploadCount.failedRow}</span>
                              </li>
                              <li>
                                <span>Passed:{dataUploadCount.successRow}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="errorlog" id="myInput">
                          <span className="errordownload">
                            <ul title="Error log download">
                              <a>
                                <img
                                  src={Images.DOWNLOAD}
                                  alt="Download"
                                  width="16px"
                                  onClick={downloadErrorLogFile}
                                />
                              </a>
                            </ul>
                          </span>
                          <PDFExport
                            paperSize="A4"
                            margin="2cm"
                            ref={pdfExportComponent}
                          >
                            <Errorlogtreeview>
                              {renderSubtrees(errorDataList)}
                            </Errorlogtreeview>

                            {/* <Treebeard data={errorDataList} onToggle={onToggle} /> */}
                          </PDFExport>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </Popup>
        )}
        {isvalidatepopup === true && (
          <Window
            // title={isRiskImport ? "Risks" : "Actions"}
            onClose={cancelvalidate}
            className="excelvalidation"
            initialLeft={100}
            initialTop={50}
            initialWidth={1200}
            initialHeight={1200}
          >
            <div className="validateriskpopup">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className="validate_header" style={{ marginLeft: "10px" }}>
                  {isRiskImport === true ? "Risks" : "Actions"}{" "}
                </div>
              </div>
              <div className="btnCont">
                <div
                  className="action_btn"
                  style={{ justifyContent: "flex-start", marginTop: "5px" }}
                >
                  <ul className="Rowcount">
                    <li>
                      <span
                        style={
                          riskValidationDataCount.newRiskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "rgb(181 61 202)",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Created Records:{" "}
                        {riskValidationDataCount.newRiskCount}
                      </span>
                    </li>
                    <li>
                      <span
                        style={
                          riskValidationDataCount.modifiedRiskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#3cb34d",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Updated Records:{" "}
                        {riskValidationDataCount.modifiedRiskCount}
                      </span>
                    </li>
                    <li>
                      <span
                        style={
                          riskValidationDataCount.closedRiskCount === 0
                            ? { fontWeight: "normal", fontSize: "12px" }
                            : {
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "#428fed",
                                padding: "5px",
                                borderRadius: "5px",
                              }
                        }
                      >
                        Total Closed Records:{" "}
                        {riskValidationDataCount.closedRiskCount}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              {isRiskImport === true ? (
                <div className="tblCont dataGrids" id="validategrid">
                  <ValidateRisk
                    workstreamId={parseInt(
                      props.match.params.organizationUnitId
                    )}
                    orgUnit={orgUnit}
                    riskData={data}
                    handleValidateDataCount={handleValidateDataCount}
                    loader={loader}
                  ></ValidateRisk>
                </div>
              ) : (
                <div className="tblCont dataGrids" id="validategrid">
                  <ValidateAction
                    workstreamId={parseInt(
                      props.match.params.organizationUnitId
                    )}
                    orgUnit={orgUnit}
                    handleValidateDataCount={handleValidateDataCount}
                    loader={loader}
                  ></ValidateAction>
                </div>
              )}

              <div className="btnCont">
                <div className="action_btn">
                  <button
                    className="Submit__btn"
                    onClick={() => commitRisk("commit")}
                    id="validatesubmit"
                  >
                    Commit
                  </button>
                  <button
                    className="validate_cancelbtn"
                    style={{ marginTop: "0px" }}
                    onClick={() => commitRisk("uncommit")}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Window>
        )}

        <div className="mainWrapper">
          <div className="dashboardCont RiskConts RiskListContainer">
            <h2>{orgUnit.unitName}</h2>
            <div className="dbGrids">
              <div className="dbRow">
                <div className="dbCol rBox">
                  <div className="gBox">
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Risks</p>
                        <h4>
                          {riskCount.totalRiskCount
                            ? riskCount.totalRiskCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Risks</p>
                        <h4>
                          {riskCount.openRiskCount
                            ? riskCount.openRiskCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Closed Risks</p>
                        <h4>
                          {riskCount.closedRiskCount
                            ? riskCount.closedRiskCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.ASSESSMENT}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Total Actions</p>
                        <h4>
                          {actionCount.totalActionCount
                            ? actionCount.totalActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.WARNING} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Open Actions</p>
                        <h4>
                          {actionCount.openActionCount
                            ? actionCount.openActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CLOSEDRISK}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Closed Actions</p>
                        <h4>
                          {actionCount.closedActionCount
                            ? actionCount.closedActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Original Overdue Actions</p>
                        <h4>
                          {actionCount.overdueActionCount
                            ? actionCount.overdueActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img src={Images.VIEWDATA} width="16" alt="Dashboard" />
                      </div>
                      <div className="dbConfigData">
                        <p>Projected Overdue Actions</p>
                        <h4>
                          {actionCount.projectedOverdueActionCount
                            ? actionCount.projectedOverdueActionCount
                            : 0}
                        </h4>
                      </div>
                    </div>

                    {/* ----New--- */}
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.UNAPPROVE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Unapproved Action Cost</p>
                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {aggregationsCount.unApprovedRiskBudget
                            ? formatNumber(
                                aggregationsCount.unApprovedRiskBudget,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="iconBox">
                        <img
                          src={Images.CHECKCIRCLE}
                          width="16"
                          alt="Dashboard"
                        />
                      </div>
                      <div className="dbConfigData">
                        <p>Approved Action Cost</p>
                        <h4>
                          {secureLocalStorage.getItem("currency")}
                          {aggregationsCount.riskBudgetApproved
                            ? formatNumber(
                                aggregationsCount.riskBudgetApproved,
                                "##,#"
                              )
                            : 0}
                        </h4>
                      </div>
                    </div>

                    <div className="d-flex rskBtn">
                      <div className="ml-auto primaryBtn mitigationBtns">
                        <button onClick={ImpactRatingOpen}>Rating Table</button>
                      </div>

                      <ul>
                        <li
                          onClick={exportPDF}
                          title="Export Risks PDF"
                        >
                          <a>
                            <img src={Images.PDF} alt="Export PDF" width="16" />
                          </a>
                        </li>
                        <li onClick={exportExcel} title="Export Excel">
                          <a>
                            <img
                              src={Images.XLSX}
                              alt="Export Risk Excel"
                              width="20"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rw-tab-cont">
              <div className="d-flex">
                <ul className="rw-nav rw-nav-tabs">
                  <li className="rw-nav-item">
                    <a className="rw-nav-link active">Risks ({data.length})</a>
                  </li>
                  <span style={{ color: "#ffffff", fontSize: "12px",paddingTop: "6px" }}>{"Hide Action Columns"}&nbsp;</span>
                  <li className="rw-nav-item">
                  <div className="showhidecols" >
                    <MultiSelect
                      // placeholder="Hide Action Columns"
                      onChange={(e) =>handleSelectedActionsColumnFields(e)}
                      onClose={(e) =>saveColumnSettings(e,"Action")}
                      value={selectedActionsColumnFields}
                      data={actionsColumnFields}
                      itemRender={itemRenderAction}
                      valueField="fieldName"
                      textField="displayName"
                      dataItemKey="fieldName"
                      filterable={false}
                      autoClose={false}
                      tags={
                        selectedActionsColumnFields.length > 0
                          ? [
                              {
                                text: `${selectedActionsColumnFields.length} Action columns are hidden`,
                                data: [...selectedActionsColumnFields],
                              },
                            ]
                          : []
                      }
                    />
                  </div>
                  </li>
                  <span style={{  color: "#ffffff", fontSize: "12px",paddingTop: "6px" }}>{'Hide Risk Columns'}&nbsp;</span>
                  <li className="rw-nav-item">
                  <div className="showhidecols">
                    <MultiSelect
                      // placeholder="Hide Risk Columns"
                      onChange={(e) =>handleSelectedRisksColumnFields(e)}
                      onClose={(e) =>saveColumnSettings(e,"Risk")}
                      value={selectedRisksColumnFields}
                      data={risksColumnFields}
                      itemRender={itemRenderRisk}
                      valueField="fieldName"
                      textField="displayName"
                      dataItemKey="fieldName"
                      filterable={false}
                      autoClose={false}
                      tags={
                        selectedRisksColumnFields.length > 0
                          ? [
                              {
                                text: `${selectedRisksColumnFields.length} Risk columns are hidden`,
                                data: [...selectedRisksColumnFields],
                              },
                            ]
                          : []
                      }
                    />
                  </div>
                  </li>
                  {/* <li className="rw-nav-item">
                    <a className="rw-nav-link">Opportunities (0)</a>
                  </li>
                  <li className="rw-nav-item">
                    <a className="rw-nav-link">Elevated Risks (0)</a>
                  </li> */}
                  {/* <li className="rw-nav-item">
                    <a className="rw-nav-link">Documents (0)</a>
                  </li>
                  <li className="rw-nav-item">
                    <a className="rw-nav-link">Project Details</a>
                  </li> */}
                </ul>
                <div className="ml-auto d-flex">
                

                  <button
                    className="addRisks"
                    onClick={() => resetPopupOpen("ACTION")}
                  >
                    Reset Action
                  </button>
                  <button
                    className="addRisks"
                    onClick={() => resetPopupOpen("RISK")}
                  >
                    Reset Risk
                  </button>

                  {workstreamRole == "Standard User" ||
                  workstreamRole == "View Only" ? (
                    ""
                  ) : (
                    <div>
                      <button
                        className="addRisks"
                        onClick={openCopyRiskAndActionPopup}
                      >
                        Copy Risk/Action
                      </button>
                      <button
                        className="addRisks"
                        onClick={() => handleOpenExportDialog(true)}
                      >
                        Import Risk
                      </button>
                      <button
                        className="addRisks"
                        onClick={() => handleOpenExportDialog(false)}
                      >
                        Import Action
                      </button>
                    </div>
                  )}
                  {workstreamRole == "Standard User" ||
                  workstreamRole == "View Only"
                    ? ""
                    : addRiskBtnFlag && (
                        <button className="addRisks" onClick={openRiskFormView}>
                          Add Risk
                        </button>
                      )}
                  {/* <button className="addRisks" onClick={openRiskFormView}>
                    Add Risk Form View
                  </button> */}
                </div>
              </div>

              <div className="rw-tab-content" id="rw-tab-header">
                <div className="rw-tab-pane  active" id="risk-register">
                  <div
                    className="tblCont riskRegister dataGrids riskRegTable riskDataGrid"
                    id="DataGrid"
                  >
                    <>
                    {showGrid ?( <ExcelExport data={data}>{riskGrid}</ExcelExport>):(<p className="refreshGrid" >Refreshing grid, please wait...</p>)}
                      <ExcelExport
                        data={data}
                        fileName={
                          orgUnit.unitName
                            ? orgUnit.unitName.replace(".", " ")
                            : "Risk" + ".xlsx"
                        }
                        // ref={(exporter) => (_export = exporter)}
                        ref={_exporter}
                        headerPaddingCellOptions={{
                          background: "#ff0000",
                        }}
                      >
                        {riskgrid1}
                      </ExcelExport>
                      <ExcelExport
                        data={action}
                        fileName={
                          orgUnit.unitName
                            ? orgUnit.unitName.replace(".", " ")
                            : "Action" + ".xlsx"
                        }
                        ref={_exporterAction}
                        headerPaddingCellOptions={{
                          background: "#ff0000",
                        }}
                      >
                        {actionGrid3}
                      </ExcelExport>
                    </>

                    <GridPDFExport
                      ref={(pdfExport) => (gridPDFExport = pdfExport)}
                      fileName={
                        orgUnit.unitName
                          ? orgUnit.unitName.replace(".", " ")
                          : "Risk" + ".pdf"
                      }
                      margin="1cm"
                      date={new Date()}
                      // paperSize={["1000mm", "400mm"]}
                      paperSize={"auto"}
                      title={title + " " + CreatedDate}
                      repeatHeaders={true}
                    >
                      {exportGrid}
                    </GridPDFExport>
                  </div>
                </div>
                <div className="rw-tab-pane  fade">
                  {/* Oppertunities Container  */}
                </div>
                <div className="rw-tab-pane  fade">
                  {/* Elivated Container  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Popup show={openDeleteModelFlag} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="deleteModelCont">
          <h3>
            {mitigationCount > 0
              ? "Actions associated with this Risk, Are you sure you want to delete this Risk?"
              : "Are you sure you want to delete this Risk?"}
          </h3>
          <div className="btnCont">
            <button onClick={() => deleteRisk()} className="deleteBtn">
              Delete
            </button>
            <button onClick={deleteRiskPopupClose} className="cancelBtn">
              Cancel
            </button>
          </div>
        </div>
      </Popup>

      <Popup show={openPdfTitlePopup} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        <div className="addTypeForm">
          <div className="fieldCont">
            <label>Enter Title</label>
            <input
              type="text"
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
              value={title}
              required
            />
          </div>
          <div className="btnGroup">
            <button
              disabled={!title}
              className="btnPrimary"
              onClick={exportPDF}
            >
              Export
            </button>
            <button className="btnDark" onClick={pdfTitlePopupClose}>
              Cancel
            </button>
          </div>
        </div>
      </Popup>

      <Popup show={resetPopup} popupClass={"popup-content"}>
        {loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="deleteModelCont">
          <h3>
            {riskOrAction === "RISK"
              ? "Are you sure that you want to reset the Risk register to its default settings?"
              : "Are you sure that you want to reset the  Action register to its default settings?"}
          </h3>
          <div className="btnCont">
            <button
              onClick={() =>
                riskOrAction === "RISK"
                  ? resetPersistence()
                  : resetActionPersistence()
              }
              className="deleteBtn"
            >
              Reset
            </button>
            <button onClick={resetPopupClose} className="cancelBtn">
              Cancel
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
}
